webpackJsonp([363],{

/***/ "++vR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("6oYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4e39bcf1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("YZN7");
function injectStyle (ssrContext) {
  __webpack_require__("+wow")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e39bcf1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4e39bcf1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+9ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-alert',
  computed: {
    alertClass: function alertClass() {
      return {
        'with-close': this.withCloseBtn,
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info'
      };
    }
  },
  props: {
    type: {
      type: String,
      default: 'success'
    },
    withCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hidden: false
    };
  },

  methods: {
    hide: function hide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "+Fe/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+mwj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-checkbox form-check abc-checkbox",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._t("label",[_vm._v(_vm._s(_vm.label))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+s3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),

/***/ "+tWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "+wow":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/2Db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__ = __webpack_require__("fJoC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79be115e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__ = __webpack_require__("+mwj");
function injectStyle (ssrContext) {
  __webpack_require__("9EoJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79be115e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/6sE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.isAuth && !_vm.isShareTrip)?_c('auth-layout'):_vm._e(),_vm._v(" "),(!_vm.isAuth && !_vm.isShareTrip)?_c('layout'):_vm._e(),_vm._v(" "),(_vm.isShareTrip)?_c('trip-layout'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Jsy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-radio-button form-check radio abc-radio",class:_vm.additionalClasses},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checkState},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_c('span',{staticClass:"abc-label-text"},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/VHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__ = __webpack_require__("4IzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__ = __webpack_require__("10Vv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__ = __webpack_require__("WOMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__ = __webpack_require__("ehv0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__ = __webpack_require__("NHch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__ = __webpack_require__("zb58");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chart',
  props: ['data', 'options', 'type'],
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__["a" /* default */],
    VerticalBarChart: __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__["a" /* default */],
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__["a" /* default */],
    DonutChart: __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__["a" /* default */],
    BubbleChart: __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__["a" /* default */]
  }
});

/***/ }),

/***/ "/XqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__("2QDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__ = __webpack_require__("Ci0K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__ = __webpack_require__("jrTD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__ = __webpack_require__("VoWT");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-progress-bar',
  components: {
    HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__["a" /* default */],
    VerticalBar: __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__["a" /* default */],
    CircleBar: __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__["a" /* default */]
  },
  props: {
    type: {
      type: String,
      default: 'horizontal'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: 'basic'
    },
    colorName: {
      type: String,
      default: 'primary'
    },
    startColorName: {
      type: String,
      default: 'lighterGray'
    },
    backgroundColorName: {
      type: String,
      default: 'white'
    }
  },
  watch: {
    value: function value() {
      this.animateValue();
    }
  },
  methods: {
    animateValue: function animateValue() {
      var _this = this;

      var startValue = this.value;
      var valueMsecs = this.valueAnimationInterval / this.max;
      var delta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(this.value - this.animatedValue);
      var valueInterval = setInterval(function () {
        if (!_this.$refs.bar) {
          clearInterval(valueInterval);
          return;
        }
        if (startValue !== _this.value || _this.animatedValue === _this.value) {
          clearInterval(valueInterval);
          if (_this.value === _this.max) {
            _this.isActive = false;
          }
        } else {
          _this.animatedValue += delta;
        }
      }, valueMsecs);
    }
  },
  data: function data() {
    return {
      value: 0,
      valueAnimationInterval: 2000,
      animatedValue: 0,
      isActive: false,
      startColor: this.$store.state.app.config.palette[this.startColorName],
      color: this.$store.state.app.config.palette[this.colorName],
      backgroundColor: this.$store.state.app.config.palette[this.backgroundColorName]
    };
  }
});

/***/ }),

/***/ "0CcK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("obAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5dafc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("BkB6");
function injectStyle (ssrContext) {
  __webpack_require__("C/vs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5dafc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0HaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("YMqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b556ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("DNx1");
function injectStyle (ssrContext) {
  __webpack_require__("KZ66")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b556ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0MOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tabs"},[_c('div',{staticClass:"d-none d-md-block dm-lg-block dm-xl-block"},[_c('nav',{staticClass:"nav nav-pills row"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"nav-item col",class:{active: name === _vm.currentActive},on:{"click":function($event){_vm.setActive(name)}}},[_c('span',{staticClass:"nav-link"},[_c('h5',[_vm._v(_vm._s(name))])])])})),_vm._v(" "),_c('div',{staticClass:"track"},[_c('div',{class:_vm.underscoreClass})])]),_vm._v(" "),_c('vuestic-simple-select',{staticClass:"d-flex d-md-none d-lg-none d-xl-none simple-select",attrs:{"options":_vm.names},model:{value:(_vm.currentActive),callback:function ($$v) {_vm.currentActive=$$v},expression:"currentActive"}}),_vm._v(" "),_c('div',{staticClass:"tab-content"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"tab-pane",class:{active: name === _vm.currentActive}},[_vm._t(name)],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Zxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'padronAICM',
  meta: {
    expanded: false,
    title: 'Padrón',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [{
    path: '/config-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'menu.drivers'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriversList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverNew'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':driverId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    path: '/config-holders',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Permisionarios'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderList'),
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: ':holderId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }]
  }, {
    path: '/config-cars',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Vehículos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarsList'),
      meta: {
        title: 'Vehículos'
      }
    }, {
      path: ':carId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarView'),
      props: true,
      meta: {
        title: 'Vehículo'
      }
    }]
  }, {
    path: '/expired-documents',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Documentos Vencidos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ExpiredDocumentsList'),
      meta: {
        title: 'Documentos Vencidos'
      }
    }]
  }]
});

/***/ }),

/***/ "1/u9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "10Vv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bubble"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "10yw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: Number
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },
  mounted: function mounted() {
    this.selectedItemsPerPage(this.selected);
  },


  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      this.selected = optionValue;
      this.$emit('items-per-page', this.selected);
    }
  }
});

/***/ }),

/***/ "19/3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1KK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticTreeCategory__ = __webpack_require__("WXh0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuesticTreeNode__ = __webpack_require__("IkPp");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VuesticTreeNode: __WEBPACK_IMPORTED_MODULE_1__VuesticTreeNode__["a" /* default */], VuesticTreeCategory: __WEBPACK_IMPORTED_MODULE_0__VuesticTreeCategory__["a" /* default */] }
});

/***/ }),

/***/ "1mf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("vi3p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fde1817_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("DG5k");
function injectStyle (ssrContext) {
  __webpack_require__("jFr3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fde1817"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fde1817_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1xaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__ = __webpack_require__("7VXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc44f0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__ = __webpack_require__("j+1F");
function injectStyle (ssrContext) {
  __webpack_require__("8kF1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc44f0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2+uQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'finanzaporto',
  meta: {
    expanded: false,
    title: 'Finanzas',
    iconClass: 'fa fa-money'
  },
  children: [{
    name: 'pagos',
    path: '/pagos',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/payments/PaymentListTab'),
    meta: {
      title: 'Consulta Pagos',
      requiresAuth: true
    }
  }, {
    name: 'ticketsFinancialDeposits',
    path: '/financial/deposits',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Pagos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DepositList'),
      meta: {
        title: 'Pagos'
      }
    }, {
      name: 'depositDetail',
      path: ':depositId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DepositDetail'),
      props: true,
      meta: {
        title: 'Detalle del Pago'
      }
    }]
  }, {
    name: 'clarificationTicket',
    path: '/utils/clarification-ticket',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/AssignTicket'),
    meta: {
      title: 'Aclaración de Boletos',
      requiresAuth: true
    }
  }, {
    name: 'processDay',
    path: '/utils/process-day',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/ProcessDay'),
    meta: {
      title: 'Proceso del Día',
      requiresAuth: true
    }
  }, {
    name: 'processWeek',
    path: '/utils/process-week',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/ProcessWeek'),
    meta: {
      title: 'Proceso Semanal',
      requiresAuth: true
    }
  }]
});

/***/ }),

/***/ "2Bcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        if (i === 1) {
          style.marginLeft = 0;
        }

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "2Nev":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_components_vuestic_alert_VuesticAlert_vue__ = __webpack_require__("EV/8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_components_vuestic_breadcrumbs_VuesticBreadcrumbs_vue__ = __webpack_require__("vh2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuestic_components_vuestic_chart_VuesticChart_vue__ = __webpack_require__("tgcS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuestic_components_vuestic_chat_VuesticChat_vue__ = __webpack_require__("Gu02");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__ = __webpack_require__("/2Db");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuestic_components_vuestic_datatable_VuesticDataTable_vue__ = __webpack_require__("0CcK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_VuesticSimpleTable_vue__ = __webpack_require__("Xdnb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_feed_VuesticFeed_vue__ = __webpack_require__("M9rz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__ = __webpack_require__("u+5M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuestic_components_vuestic_modal_VuesticModal_vue__ = __webpack_require__("uxTM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__ = __webpack_require__("1xaq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuestic_components_vuestic_popover_VuesticPopover_vue__ = __webpack_require__("ihPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("9xHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__ = __webpack_require__("9NsT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__ = __webpack_require__("niZM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__ = __webpack_require__("BdMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("Y+KL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__ = __webpack_require__("0HaH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vuestic_components_vuestic_slider_VuesticSlider_vue__ = __webpack_require__("fPvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__vuestic_components_vuestic_social_news_VuesticSocialNews_vue__ = __webpack_require__("W3ZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__vuestic_components_vuestic_switch_VuesticSwitch_vue__ = __webpack_require__("yPiP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vuestic_components_vuestic_tabs_VuesticTabs_vue__ = __webpack_require__("K08g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__vuestic_components_vuestic_tooltip_VuesticTooltip_vue__ = __webpack_require__("xQQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__vuestic_components_vuestic_widget_VuesticWidget_vue__ = __webpack_require__("TVMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__vuestic_components_vuestic_wizard_VuesticWizard_vue__ = __webpack_require__("aHv1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__vuestic_components_vuestic_tree_view_VuesticTreeRoot__ = __webpack_require__("vHzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__vuestic_components_vuestic_tree_view_VuesticTreeCategory__ = __webpack_require__("WXh0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__vuestic_components_vuestic_tree_view_VuesticTreeNode__ = __webpack_require__("IkPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__vuestic_mixins_VuesticToasted__ = __webpack_require__("fB5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__vuestic_directives_StickyScroll__ = __webpack_require__("qLPH");


































var VuesticPlugin = {
  install: function install(Vue, options) {
    [__WEBPACK_IMPORTED_MODULE_0__vuestic_components_vuestic_alert_VuesticAlert_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__vuestic_components_vuestic_breadcrumbs_VuesticBreadcrumbs_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__vuestic_components_vuestic_chart_VuesticChart_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__vuestic_components_vuestic_chat_VuesticChat_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__vuestic_components_vuestic_checkbox_VuesticCheckbox_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__vuestic_components_vuestic_datatable_VuesticDataTable_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_VuesticSimpleTable_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__vuestic_components_vuestic_feed_VuesticFeed_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__vuestic_components_vuestic_modal_VuesticModal_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__vuestic_components_vuestic_radio_button_VuesticRadioButton_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__vuestic_components_vuestic_slider_VuesticSlider_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__vuestic_components_vuestic_switch_VuesticSwitch_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__vuestic_components_vuestic_tabs_VuesticTabs_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__vuestic_components_vuestic_widget_VuesticWidget_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__vuestic_components_vuestic_wizard_VuesticWizard_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__vuestic_components_vuestic_medium_editor_VuesticMediumEditor_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__vuestic_components_vuestic_tooltip_VuesticTooltip_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__vuestic_components_vuestic_popover_VuesticPopover_vue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__vuestic_components_vuestic_tree_view_VuesticTreeRoot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__vuestic_components_vuestic_tree_view_VuesticTreeCategory__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__vuestic_components_vuestic_tree_view_VuesticTreeNode__["a" /* default */]].forEach(function (component) {
      Vue.component(component.name, component);
    });

    Vue.mixin(__WEBPACK_IMPORTED_MODULE_28__vuestic_mixins_VuesticToasted__["a" /* default */]);

    Vue.directive('dropdown', __WEBPACK_IMPORTED_MODULE_29__vuestic_directives_Dropdown__["a" /* default */]);
    Vue.directive('sticky-scroll', __WEBPACK_IMPORTED_MODULE_30__vuestic_directives_StickyScroll__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VuesticPlugin);

/***/ }),

/***/ "2ab3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ "2ek5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2u3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),

/***/ "3Alh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "3VgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__ = __webpack_require__("eOeK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__ = __webpack_require__("/2Db");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-category',
  components: { SquareWithIcon: __WEBPACK_IMPORTED_MODULE_0__vuestic_div_checkbox_SquareWithIcon_vue__["a" /* default */], VuesticCheckbox: __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__["a" /* default */] },
  data: function data() {
    return {
      isOpenCached: false
    };
  },

  watch: {
    isOpen: {
      handler: function handler(isOpen) {
        this.isOpenCached = isOpen;
      },

      immediate: true
    }
  },
  props: {
    label: {
      type: [String, Number],
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxIconClass: function checkboxIconClass() {
      return this.isOpenCached ? 'ion ion-md-remove' : 'ion ion-md-add';
    }
  },
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.isOpenCached = false;
      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.isOpenCached = true;
      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "3w5z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4IzE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Pie"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "4J/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-popover',

  components: { VPopover: __WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* VPopover */] },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'auto'
    },
    popoverClass: {
      type: [String, Array],
      default: 'vuestic-tooltip'
    },
    autoHide: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isIconPresent: function isIconPresent() {
      return !!this.$slots.icon;
    }
  }
});

/***/ }),

/***/ "4TJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__("2ab3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4bUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("tcEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2da26f99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("ArqU");
function injectStyle (ssrContext) {
  __webpack_require__("Dl4e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2da26f99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2da26f99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5zUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-modal"},[_c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "67bY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tickets',
  meta: {
    expanded: false,
    title: 'Finanzas',
    iconClass: 'fa fa-money'
  },
  children: [{
    name: 'dashboardCharts',
    path: '/financial/dashboard-charts',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/dashboardCharts/DashboardCharts'),
    meta: {
      title: 'Dashboard de Ventas',
      requiresAuth: true
    }
  }, {
    name: 'cobros',
    path: '/cobros',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debitPayments/DebitPaymentList'),
    meta: {
      title: 'Consulta Cobros',
      requiresAuth: true
    }
  }, {
    name: 'pagos',
    path: '/pagos',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/payments/PaymentListTab'),
    meta: {
      title: 'Consulta Pagos',
      requiresAuth: true
    }
  }, {
    name: 'ticketsFinancialDeposits',
    path: '/financial/deposits',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Pagos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DepositList'),
      meta: {
        title: 'Pagos'
      }
    }, {
      name: 'depositDetail',
      path: ':depositId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DepositDetail'),
      props: true,
      meta: {
        title: 'Detalle del Pago'
      }
    }]
  }, {
    name: 'clarificationTicket',
    path: '/utils/clarification-ticket',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/AssignTicket'),
    meta: {
      title: 'Aclaración de Boletos',
      requiresAuth: true
    }
  }, {
    name: 'ticketsDebits',
    path: '/debits',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/Main'),
    meta: {
      title: 'Adeudos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/List'),
      meta: {
        title: 'Adeudos'
      }
    }, {
      path: ':debitId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/View'),
      props: true,
      meta: {
        title: 'Adeudo'
      }
    }]
  }, {
    name: 'InvoiceList',
    path: '/invoices',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/invoices/InvoiceList'),
    meta: {
      title: 'Facturas Emitidas',
      requiresAuth: true
    }
  }, {
    name: 'financialTicketScheduled',
    path: '/financial/ticket-scheduled',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Retornos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/TicketScheduledList'),
      meta: {
        title: 'Ticket Retorno Asignados'
      }
    }]
  }, {
    name: 'sales',
    path: '/sales',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/sales/List'),
    meta: {
      title: 'Ventas',
      requiresAuth: true
    }
  }, {
    name: 'financialAircabSalesCompany',
    path: '/financial/aircab-sales-company',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Aircab Venta'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/Company/AircabList'),
      meta: {
        title: 'Lista Aircab'
      }
    }]
  }, {
    name: 'financialCallcenterSalesCompany',
    path: '/financial/callcenter-sales-company',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Callcenter Venta'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/Company/CallcenterList'),
      meta: {
        title: 'Lista Callcenter'
      }
    }]
  }, {
    name: 'driverCut',
    path: '/utils/driver-cut',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/DriverCut'),
    meta: {
      title: 'Corte Por Unidad',
      requiresAuth: true
    }
  }, {
    name: 'driverCut',
    path: '/utils/deposit-list-car',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DepositListCar'),
    meta: {
      title: 'Pagos por Unidad',
      requiresAuth: true
    }
  }]
});

/***/ }),

/***/ "68r5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-sm dropdown-toggle",attrs:{"id":"itemsPerPageBtn","type":"button","data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+" per page\n    "),_c('i',{staticClass:"ion-ios-arrow-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value)+" per page")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6b77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-node",class:{'vuestic-tree-node-selected': _vm.selected}},[(_vm.$slots.checkbox)?_c('div',{staticClass:"vuestic-tree-node-checkbox"},[_vm._t("checkbox")],2):_vm._e(),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-node-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-node-label"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.iconRight)?_c('div',{staticClass:"vuestic-tree-node-icon-right"},[_vm._t("iconRight")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6oYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "7F3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__("4TJE");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ "7HrZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circles-to-rhombuses-spinner",style:(_vm.spinnertStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7VXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("Y+KL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-multi-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["a" /* default */]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    options: Array,
    value: Array,
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'multiselect'
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    toggleSelection: function toggleSelection(option) {
      var newVal = this.isOptionSelected(option) ? this.deselectOption(option) : this.selectOption(option);
      this.updateDisplayValue(newVal);
      this.$emit('input', newVal);
    },
    isOptionSelected: function isOptionSelected(option) {
      return this.value.includes(option);
    },
    selectOption: function selectOption(option) {
      return this.value.concat(option);
    },
    deselectOption: function deselectOption(option) {
      return this.value.filter(function (item) {
        return item !== option;
      });
    },
    updateDisplayValue: function updateDisplayValue(newVal) {
      var _this = this;

      if (newVal.length > 2) {
        this.displayValue = newVal.length + ' of ' + this.options.length + ' chosen';
      } else {
        this.displayValue = (this.optionKey ? newVal.map(function (item) {
          return item[_this.optionKey];
        }) : newVal).join(', ');
      }
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "7aGr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7qYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  itemsPerPage: [{
    value: 20
  }, {
    value: 50
  }, {
    value: 100
  }]
});

/***/ }),

/***/ "8+2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8P8v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"left":"420px","top":"180px","width":"400px","background-color":"white","position":"absolute"}},[_c('vuestic-tree-category',{attrs:{"label":"Category with icon"}},[_c('div',{staticClass:"icon",attrs:{"slot":"icon"},slot:"icon"},[_c('span',{staticClass:"ion ion-md-nutrition",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('vuestic-tree-node',[_vm._v("\n      One\n    ")]),_vm._v(" "),_c('vuestic-tree-node',[_vm._v("\n      Two\n    ")]),_vm._v(" "),_c('vuestic-tree-node',[_vm._v("\n      Three\n    ")])],1),_vm._v(" "),_c('vuestic-tree-category',{attrs:{"label":"Category open","isOpen":""}},[_c('vuestic-tree-node',[_vm._v("\n      One\n    ")]),_vm._v(" "),_c('vuestic-tree-node',[_vm._v("\n      Two\n    ")]),_vm._v(" "),_c('vuestic-tree-node',[_vm._v("\n      Three\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8QAW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8kF1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ovZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "8uvc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aircabReport',
  meta: {
    expanded: false,
    title: 'Reportes Aircab',
    iconClass: 'vuestic-icon vuestic-icon-statistics'
  },
  children: [{
    name: 'aircabReportTravels',
    path: '/aircab-report/travels',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Reporte Viajes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('aircabReport/TravelList'),
      meta: {
        title: 'Reporte Viajes'
      }
    }]
  }, {
    name: 'aircabReportClients',
    path: '/aircab-report/clients',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Reporte Clientes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('aircabReport/ClientList'),
      meta: {
        title: 'Reporte Clientes'
      }
    }]
  }]
});

/***/ }),

/***/ "8wbO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8zBt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9AED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "9C+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kewler__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-pre-loader',
  methods: {
    getPrevious: function getPrevious(index) {
      if (index === 0) return this.points.length - 1;else return index - 1;
    },
    getNext: function getNext(index) {
      if (index + 1 === this.points.length) {
        return 0;
      } else {
        return index + 1;
      }
    },
    setNextLighten: function setNextLighten(index) {
      var lighten = this.points[index].lighten;
      this.points[index].lighten = lighten === 8 ? 1 : lighten + 1;
    },
    draw: function draw() {
      var _this = this;

      var ctx = this.context;
      ctx.clearRect(0, 0, 140, 104);
      var padding = 4;
      this.points.forEach(function (point) {
        ctx.beginPath();
        var delta = _this.radius + padding;
        ctx.arc(point.x + delta, point.y + delta, _this.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = _this.color(Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["lightness"])(point.lighten / 10 * 35))();
        ctx.fill();
      });
      var main = this.points[this.mainIndex];
      var delta = this.mainRadius - this.radius + padding;
      ctx.beginPath();
      ctx.arc(main.x + delta, main.y + delta, this.mainRadius, 0, Math.PI * 2, false);
      ctx.fillStyle = this.color();
      ctx.fill();
      ctx.closePath();
    },
    calculate: function calculate() {
      this.mainIndex = this.getNext(this.mainIndex);
      var prevIndex = this.mainIndex;
      for (var i = 0; i <= 7; i++) {
        prevIndex = this.getPrevious(prevIndex);
        this.setNextLighten(prevIndex);
      }
    },
    update: function update() {
      this.calculate();
      this.draw();
    },
    animate: function animate() {
      this.interval = setInterval(this.update, 30);
    },
    stop: function stop() {
      clearInterval(this.interval);
    }
  },
  mounted: function mounted() {
    this.context = this.$refs.canvas.getContext('2d');
    this.points = this.points.map(function (point) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        lighten: 8
      }, point);
    });
    for (var i = 1; i <= 7; i++) {
      this.points[this.mainIndex - i].lighten = i;
    }
    this.draw();
    this.animate();
  },
  data: function data() {
    return {
      points: __webpack_require__("nErf"),
      color: Object(__WEBPACK_IMPORTED_MODULE_1_kewler__["color"])(this.$store.state.app.config.palette.primary),
      mainIndex: 7,
      context: {},
      radius: 4,
      mainRadius: 8,
      interval: {}
    };
  }
});

/***/ }),

/***/ "9EoJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9MZa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scaling-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9NO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sharedTrip',
  meta: {
    expanded: false,
    title: 'VIAJE COMPARTIDO',
    iconClass: 'vuestic-icon vuestic-icon-auth'
  },
  children: [{
    name: 'sharedTrip',
    path: '/share/:travelId',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('sharedTrip/Main'),
    meta: {
      title: 'Programados',
      requiresAuth: false
    }
  }]
});

/***/ }),

/***/ "9NsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__ = __webpack_require__("iLy1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34badcaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__ = __webpack_require__("JDxB");
function injectStyle (ssrContext) {
  __webpack_require__("rNhy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34badcaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9xHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__ = __webpack_require__("9C+P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1680f247_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__ = __webpack_require__("q2yJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1680f247_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AJrP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AO3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__ = __webpack_require__("9AED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4f7e4f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__ = __webpack_require__("l7V8");
function injectStyle (ssrContext) {
  __webpack_require__("siFy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4f7e4f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4f7e4f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AQHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"vuestic-tooltip-target"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AdJO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal"},[(_vm.size != 'thick')?_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('width: ' + _vm.value + '%')},[(_vm.size == 'thick')?_c('span',{staticClass:"value",class:{hidden: _vm.animatedValue == _vm.min}},[_vm._v("\n        "+_vm._s(_vm.animatedValue + '%')+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ApCf":
/***/ (function(module, exports) {

module.exports = {"name":"weekstart","version":"1.1.0","description":"Library to get first day of week.","homepage":"https://github.com/gamtiq/weekstart","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","umd:main":"dist/main.js","files":["dist","full.js","full.d.ts","index.d.ts","src","History.md"],"keywords":["week","start","first","day","locale","country","region"],"devDependencies":{"@babel/preset-env":"^7.13.10","eslint":"^7.22.0","eslint-config-guard":"^2.0.1","ink-docstrap":"1.3.2","jest":"^26.6.3","jsdoc":"^3.6.6","jsdoc-file":"^1.0.1","microbundle":"0.4.4","version-bump-prompt":"^6.1.0"},"scripts":{"lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","test":"jest","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.js","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","all":"npm run check-all && npm run doc && npm run build","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json"},"author":{"name":"Denis Sikuler"},"repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"license":"MIT","types":"./index.d.ts"}

/***/ }),

/***/ "ArqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-bouncing-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AyHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__ = __webpack_require__("8ovZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f854824_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__ = __webpack_require__("WHs2");
function injectStyle (ssrContext) {
  __webpack_require__("fdJM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f854824"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3f854824_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BFrm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BKK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("r8Mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_53490633_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("Y9RQ");
function injectStyle (ssrContext) {
  __webpack_require__("IQMk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53490633"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_53490633_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BOqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__ = __webpack_require__("7F3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1e1ee4d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__ = __webpack_require__("a13N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1e1ee4d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BQrv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BcT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'square-with-icon',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "BdMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__ = __webpack_require__("GFLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d84a64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__ = __webpack_require__("/Jsy");
function injectStyle (ssrContext) {
  __webpack_require__("2ek5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticRadioButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d84a64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticRadioButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BkB6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-data-table"},[(_vm.headerShown)?_c('div',{staticClass:"d-flex flex-md-row flex-column align-items-center",class:_vm.controlsAlignmentClass},[_c('filter-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.filterInputShown),expression:"filterInputShown"}],on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('div',{staticClass:"datatable-controls d-flex flex-row"},[_c('div',{staticClass:"form-group"},[_vm._t("additionalTableControl")],2),_vm._v(" "),_c('items-per-page',{directives:[{name:"show",rawName:"v-show",value:(_vm.perPageSelectorShown),expression:"perPageSelectorShown"}],attrs:{"options":_vm.itemsPerPage,"defaultPerPage":_vm.defaultPerPageComputed},on:{"items-per-page":_vm.onItemsPerPage}})],1)],1):_vm._e(),_vm._v(" "),_c('vuetable',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],ref:"vuetable",attrs:{"apiMode":_vm.apiMode,"fields":_vm.tableFields,"dataManager":_vm.dataManager,"css":_vm.css.table,"data":_vm.tableData,"paginationPath":_vm.paginationPathComputed,"appendParams":_vm.moreParams,"perPage":_vm.perPage,"detailRowClass":_vm.detailRowClass},on:{"vuetable:pagination-data":_vm.onPaginationData,"vuetable:cell-clicked":_vm.arrowClicked}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"col-md-12",staticStyle:{"padding-bottom":"30px","padding-top":"30px"}},[_c('fulfilling-square-spinner',{style:('margin: auto'),attrs:{"animation-duration":4000,"size":100,"color":'#ff1d5e'}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BmEH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'test',
  meta: {
    expanded: false,
    title: 'Pruebas',
    iconClass: 'fa fa-money'
  },
  children: [{
    name: 'reporte-deudas-personas',
    path: '/reporte-deudas-personas',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/ReporteDeudasPersonas'),
    meta: {
      title: 'Reporte Deudas Personas',
      requiresAuth: true
    }
  }, {
    name: 'UnfinishTravel',
    path: '/unfinishTravel',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/UnfinishTravelList'),
    meta: {
      title: 'Vienes Sin Terminar',
      requiresAuth: true
    }
  }, {
    name: 'ReviewList',
    path: '/reviews',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/reviews/ReviewList'),
    meta: {
      title: 'Calificaciones',
      requiresAuth: true
    }
  }, {
    name: 'PromoList',
    path: '/promos',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/promos/PromoList'),
    meta: {
      title: 'Códigos Promociones',
      requiresAuth: true
    }
  }, {
    name: 'InvoiceList',
    path: '/invoices',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/invoices/InvoiceList'),
    meta: {
      title: 'Facturas Emitidas',
      requiresAuth: true
    }
  }, {
    name: 'sales',
    path: '/sales',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/sales/List'),
    meta: {
      title: 'Ventas',
      requiresAuth: true
    }
  }, {
    name: 'financialDeposits',
    path: '/financial/deposits',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Pagos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DepositList'),
      meta: {
        title: 'Pagos'
      }
    }, {
      name: 'depositDetail',
      path: ':depositId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DepositDetail'),
      props: true,
      meta: {
        title: 'Detalle del Pago'
      }
    }]
  }, {
    name: 'clarificationTicket',
    path: '/utils/clarification-ticket',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/AssignTicket'),
    meta: {
      title: 'Aclaración de Boletos',
      requiresAuth: true
    }
  }, {
    name: 'processDay',
    path: '/utils/process-day',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/ProcessDay'),
    meta: {
      title: 'Proceso del Día',
      requiresAuth: true
    }
  }, {
    name: 'testDebits',
    path: '/debits',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/Main'),
    meta: {
      title: 'Adeudos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/List'),
      meta: {
        title: 'Adeudos'
      }
    }, {
      path: ':debitId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/View'),
      props: true,
      meta: {
        title: 'Adeudo'
      }
    }]
  }]
});

/***/ }),

/***/ "Bueh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  path: '/dashboard',

  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('dashboard/Dashboard'),
  meta: {
    default: false,
    title: 'menu.dashboard',
    iconClass: 'fa fa-dashboard',
    requiresAuth: true
  }
});

/***/ }),

/***/ "C/vs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C3zk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ci0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__ = __webpack_require__("f2UZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbb5cb42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__ = __webpack_require__("AdJO");
function injectStyle (ssrContext) {
  __webpack_require__("+Fe/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbb5cb42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CmPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticTreeNode_vue__ = __webpack_require__("IkPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__ = __webpack_require__("/2Db");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VuesticTreeNode: __WEBPACK_IMPORTED_MODULE_0__VuesticTreeNode_vue__["a" /* default */],
    VuesticCheckbox: __WEBPACK_IMPORTED_MODULE_1__vuestic_checkbox_VuesticCheckbox__["a" /* default */]
  },
  data: function data() {
    return {
      checkboxValue: false
    };
  }
});

/***/ }),

/***/ "DAzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin',
  meta: {
    expanded: false,
    title: 'Programación',
    iconClass: 'vuestic-icon vuestic-icon-settings'
  },
  children: [{
    name: 'debits',
    path: '/debits',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/Main'),
    meta: {
      title: 'Adeudos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/List'),
      meta: {
        title: 'Adeudos'
      }
    }, {
      path: ':debitId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/View'),
      props: true,
      meta: {
        title: 'Adeudo'
      }
    }, {
      path: 'edit/:debitId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/debits/Edit'),
      props: true,
      meta: {
        title: 'Adeudo'
      }
    }]
  }, {
    name: 'refunds',
    path: '/refunds',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/refunds/Main'),
    meta: {
      title: 'Reembolsos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/refunds/List'),
      meta: {
        title: 'Reembolsos'
      }
    }]
  }, {
    name: 'configSellers',
    path: '/config-sellers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Vendedores'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SellersList'),
      meta: {
        title: 'Vendedores'
      }
    }, {
      path: ':sellerId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SellerView'),
      props: true,
      meta: {
        title: 'Vendedores'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SellerView'),
      props: true,
      meta: {
        title: 'Vendedores'
      }
    }]
  }, {
    name: 'allTicketList',
    path: '/trips/all-ticket-list',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/TicketList'),
    meta: {
      title: 'Boletos Físicos',
      requiresAuth: true
    }
  }, {
    name: 'errorsServer',
    path: '/tools/error-list',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ErrorList'),
    meta: {
      title: 'Errores',
      requiresAuth: true
    }
  }, {
    name: 'configCampaing',
    path: '/config-campaing',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    props: true,
    meta: {
      title: 'Campaña'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CampaingList'),
      props: true,
      meta: {
        title: 'Campaña'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CampaingView'),
      props: true,
      meta: {
        title: 'Campaña'
      }
    }, {
      path: ':campaingId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CampaingView'),
      props: true,
      meta: {
        title: 'Campaña'
      }
    }, {
      path: ':campaingId/:promoId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PromoView'),
      props: true,
      meta: {
        title: 'Campaña'
      }
    }]
  }, {
    name: 'configSubzone',
    path: '/config-subzone',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    props: true,
    meta: {
      title: 'Sub Zonas'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SubZoneList'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      name: 'SubZoneNew',
      path: 'new/:zoneId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SubZoneView'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      name: 'SubZoneView',
      path: ':subzoneId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SubZoneView'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }]
  }, {
    name: 'configZone',
    path: '/config-zone',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    props: true,
    meta: {
      title: 'Zonas'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ZoneList'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ZoneView'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      name: 'ZoneView',
      path: ':zoneId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ZoneView'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }]
  }, {
    name: 'configPrice',
    path: '/config-price',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    props: true,
    meta: {
      title: 'Precios'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PriceList'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PriceView'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      name: 'ZoneView',
      path: ':zoneId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PriceView'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }]
  }, {
    name: 'aircabSalesAdminV1',
    path: '/financial/aircab-sales-admin-v1',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Aircab Venta'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/AircabList'),
      meta: {
        title: 'Lista Aircab'
      }
    }]
  }, {
    name: 'aircabScheduledSales',
    path: '/financial/aircab-scheduled-sales',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Aircab Vuelta Venta'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/AircabScheduledList'),
      meta: {
        title: 'Lista Vuelta Aircab'
      }
    }]
  }, {
    name: 'ticketScheduled',
    path: '/financial/ticket-scheduled',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Ticket Retorno Asignados'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/TicketScheduledList'),
      meta: {
        title: 'Ticket Retorno Asignados'
      }
    }]
  }, {
    name: 'dailySales',
    path: '/financial/daily-sales',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Cortes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DailySalesList'),
      meta: {
        title: 'Corte'
      }
    }, {
      path: ':dailySaleId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/DailySalesDetail'),
      props: true,
      meta: {
        title: 'Detalle del corte'
      }
    }]
  }, {
    name: 'processDay',
    path: '/utils/process-day',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/ProcessDay'),
    meta: {
      title: 'Proceso del Día',
      requiresAuth: true
    }
  }]
});

/***/ }),

/***/ "DG5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DNx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","name":_vm.name,"required":""},domProps:{"value":(_vm.displayValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.selectOption(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))])])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DaQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chat",staticStyle:{"height":"85%"}},[_c('div',{directives:[{name:"sticky-scroll",rawName:"v-sticky-scroll",value:({animate: true, duration: 500}),expression:"{animate: true, duration: 500}"}],staticClass:"chat-body",style:({'height': _vm.height})},_vm._l((_vm.value),function(message){return _c('div',{staticClass:"chat-message",class:{'yours': message.yours, 'alien': !message.yours}},[_vm._v("\n       "+_vm._s(message.text)+"\n    ")])})),_vm._v(" "),(_vm.isActive)?_c('div',{staticClass:"chat-controls"},[_c('fieldset',[_c('div',{staticClass:"form-group form-group-w-btn"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputMessage),expression:"inputMessage"}],attrs:{"required":"","title":""},domProps:{"value":(_vm.inputMessage)},on:{"keypress":function($event){_vm.keyHandler($event)},"input":function($event){if($event.target.composing){ return; }_vm.inputMessage=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Your message")]),_c('i',{staticClass:"bar"})]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.sendMessage()}}},[_vm._v("Send")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dl4e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DtwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-feed"},[(_vm.posts.length == 0)?_c('div',{staticClass:"empty"},[_vm._v("Your feed is empty.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('div',{staticClass:"post",class:{last: _vm.posts.indexOf(post) === _vm.posts.length - 1}},[_c('div',{staticClass:"photo-container"},[_c('div',{staticClass:"photo",style:(("background: url(" + (post.photoURL) + ")"))})]),_vm._v(" "),_c('div',{staticClass:"underscored"},[_c('span',{staticClass:"text"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(post.name))]),_vm._v(" "+_vm._s(post.text)+".")]),_vm._v(" "),_c('button',{staticClass:"btn btn-micro btn-primary btn-with-icon close-btn rounded-icon",on:{"click":function($event){_vm.removePost(post)}}},[_c('i',{staticClass:"ion-md-close ion"})])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_EXPAND_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_WITHOUT_ANIMATION; });
var TOGGLE_EXPAND_MENU_ITEM = 'TOGGLE_EXPAND_MENU_ITEM';

var CLOSE_MENU = 'CLOSE_MENU';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION';

/***/ }),

/***/ "EQYl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EV/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__ = __webpack_require__("+9ro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79394e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__ = __webpack_require__("dO+m");
function injectStyle (ssrContext) {
  __webpack_require__("Ko9l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79394e32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79394e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ej8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_demo_vue__ = __webpack_require__("YROu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c963e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_demo_vue__ = __webpack_require__("nDIv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c963e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FRPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFixedHeader)?_c('div',[_c('div',{staticClass:"vuetable-head-wrapper"},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]}),_vm._v(" "),(_vm.scrollVisible)?_c('th',{staticClass:"vuetable-gutter-col",style:({width: _vm.scrollBarWidth})}):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"vuetable-body-wrapper",style:({height: _vm.tableHeight})},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]},[_c('colgroup',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[_c('col',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass],style:({width: field.width}),attrs:{"id":'_col_' + field.name}})]:_vm._e()]})],2),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"click":function($event){_vm.onRowClicked(item, $event)},"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:itemIndex,rowField:field.sortField})],2):_vm._e()]:[_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.renderNormalField(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){_vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])])]):_c('table',{class:['vuetable', _vm.css.tableClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field),  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:itemIndex,rowField:field.sortField})],2):_vm._e()]:[(_vm.hasCallback(field))?_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.callCallback(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){_vm.onCellRightClicked(item, field, $event)}}}):_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.getObjectValue(item, field.name, ''))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){_vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FiBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-social-news"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center text-w-btn"},[_c('span',{staticClass:"text"},[_vm._v("That what users have posted about your business.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('button',{staticClass:"btn btn-micro btn-primary"},[_vm._v("VIEW")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-around photos"},_vm._l((_vm.news),function(pieceOfNews){return _c('div',{staticClass:"photo",style:(("background: url(" + (pieceOfNews.photoURL) + ")"))})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GB0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuthLayout'
});

/***/ }),

/***/ "GFLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-radio-button',
  props: {
    label: String,
    value: {
      type: String,
      default: '',
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      default: undefined
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  mounted: function mounted() {
    if (this.checked && !this.checkState) {
      this.toggle();
    }
  },

  methods: {
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      this.$emit('input', this.checkState ? '' : this.value);
    }
  },
  computed: {
    checkState: function checkState() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    },
    additionalClasses: function additionalClasses() {
      return ['abc-radio-' + this.brandColor];
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.checkState) {
        this.toggle();
      }
    }
  }
});

/***/ }),

/***/ "Gi9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__("ZVky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);

__WEBPACK_IMPORTED_MODULE_0_parse___default.a.initialize("bBzZ7wYYGIpQkPPB");
__WEBPACK_IMPORTED_MODULE_0_parse___default.a.serverURL = "https://devaircab4.eboletos.com.mx/parse";
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_parse___default.a);

/***/ }),

/***/ "GofC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GoiS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gu02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__ = __webpack_require__("gMVf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2498c50a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__ = __webpack_require__("DaQt");
function injectStyle (ssrContext) {
  __webpack_require__("waXG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2498c50a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2498c50a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H65f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "HKGv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hqax":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IJwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'monitor',
  path: '/maps/DriverMonitor',

  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('monitor/google-maps/GoogleMapsPage'),
  meta: {
    default: false,
    title: 'Monitoreo',
    iconClass: 'va-icon entypo entypo-monitor',
    requiresAuth: true
  }
});

/***/ }),

/***/ "IQ8j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "IQMk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__("kmDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_menu__ = __webpack_require__("ZEli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("UjVw");









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_4__modules_menu__["a" /* default */]
  },
  state: {},
  mutations: {}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, store);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IkPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__ = __webpack_require__("Z6hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3660441d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__ = __webpack_require__("6b77");
function injectStyle (ssrContext) {
  __webpack_require__("Jf4u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3660441d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ImtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driverCard',
  meta: {
    expanded: false,
    title: 'TARJETON',
    iconClass: 'vuestic-icon vuestic-icon-auth',
    isShareTrip: true
  },
  children: [{
    name: 'driverCard',
    path: '/p1/:driverId',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverCard'),
    meta: {
      title: 'Tarjeton',
      requiresAuth: false,
      isShareTrip: true
    }
  }]
});

/***/ }),

/***/ "JDxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-profile-card d-flex flex-column align-items-center"},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.photoSource}})]),_vm._v(" "),_c('h5',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticClass:"location"},[_c('span',{staticClass:"icon glyphicon glyphicon-map-marker"}),_vm._v(" "+_vm._s(_vm.location))]),_vm._v(" "),_c('div',{staticClass:"social"},[(_vm.social.facebook)?_c('a',{staticClass:"icon brandico brandico-facebook-rect",attrs:{"href":'http://' + _vm.social.facebook,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.instagram)?_c('a',{staticClass:"icon brandico brandico-instagram",attrs:{"href":'http://' + _vm.social.instagram,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.twitter)?_c('a',{staticClass:"icon brandico brandico-twitter",attrs:{"href":'http://' + _vm.social.twitter,"target":"_blank"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JT6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("2Bcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4518f8f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("7HrZ");
function injectStyle (ssrContext) {
  __webpack_require__("GofC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4518f8f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4518f8f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jf4u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jjo6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jo31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'supervisor',
  meta: {
    expanded: false,
    title: 'Supervisor',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [{
    name: 'SupervisorDashboard',
    path: '/supervisor/dashboard',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('supervisor/dashboard/dashboard'),
    meta: {
      title: 'Dashboard'
    }
  }, {
    name: 'SupervisorMonitor',
    path: '/supervisor/monitor',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('monitor/google-maps/SupervisorGoogleMapsPage'),
    meta: {
      title: 'Monitor Supervisor'
    }
  }, {
    name: 'SupervisorSales',
    path: '/supervisor/sales',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/Main'),
    meta: {
      title: 'Ventas'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/Sales'),
      meta: {
        title: 'Ventas'
      }
    }]
  }, {
    name: 'supervisorDriver',
    path: '/supervisor-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/Main'),
    meta: {
      title: 'Conductores'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/DriversList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: ':driverId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/DriverView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'supervisorCars',
    path: '/supervisor-cars',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/Main'),
    meta: {
      title: 'Vehículos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/CarsList'),
      meta: {
        title: 'Vehículos'
      }
    }, {
      path: ':carId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/supervisor/CarView'),
      props: true,
      meta: {
        title: 'Vehículo'
      }
    }]
  }]
});

/***/ }),

/***/ "K08g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__ = __webpack_require__("kfHw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfd6272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__ = __webpack_require__("0MOa");
function injectStyle (ssrContext) {
  __webpack_require__("BQrv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfd6272_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K82C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("ml8A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5acb9782_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("cPxT");
function injectStyle (ssrContext) {
  __webpack_require__("eJuD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5acb9782"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5acb9782_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KMiR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: 'table table-striped',
    ascendingIcon: 'entypo entypo-up-dir',
    descendingIcon: 'entypo entypo-down-dir'
  },
  pagination: {
    wrapperClass: 'btn-group',
    activeClass: 'focus',
    disabledClass: 'disabled',
    pageClass: 'btn btn-primary hide-not-focused-btn',
    linkClass: 'btn btn-primary pagination-link-btn',
    icons: {
      first: 'fa fa-angle-double-left',
      prev: 'fa fa-angle-left',
      next: 'fa fa-angle-right',
      last: 'fa fa-angle-double-right'
    }
  }
});

/***/ }),

/***/ "KZ66":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KeHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TripLayout_vue__ = __webpack_require__("gJkK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565c65f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TripLayout_vue__ = __webpack_require__("LqJI");
function injectStyle (ssrContext) {
  __webpack_require__("8+2+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TripLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565c65f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TripLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ko9l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kss2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filterBar',
  props: {
    label: {
      type: String
    }
  },
  data: function data() {
    return {
      filterText: '',
      typingTimeout: null,
      typingDelay: 250
    };
  },

  methods: {
    doFilter: function doFilter() {
      var _this = this;

      this.typingTimeout && clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(function () {
        return _this.$emit('filter', _this.filterText);
      }, this.typingDelay);
    }
  }
});

/***/ }),

/***/ "LqJI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trip-layout"},[_c('div',{staticClass:"main"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M7fT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_demo_vue__ = __webpack_require__("CmPy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_784792c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_demo_vue__ = __webpack_require__("dG/A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeNode_demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_784792c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeNode_demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec344da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("/6sE");
function injectStyle (ssrContext) {
  __webpack_require__("SmvZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec344da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9rz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__ = __webpack_require__("qB2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb339f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__ = __webpack_require__("DtwO");
function injectStyle (ssrContext) {
  __webpack_require__("Jjo6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb339f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MEVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__ = __webpack_require__("QI9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__ = __webpack_require__("jEUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__ = __webpack_require__("noQ4");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__["default"],
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__["default"]
  },
  directives: {
    resize: __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['sidebarOpened', 'toggleWithoutAnimation', 'isLoading']), {
    classObject: function classObject() {
      return {
        'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
        'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
      };
    },
    breadcrumbs: function breadcrumbs() {
      if (this.$route.matched.length > 0) {
        var path = this.$route.matched[0].path;
        if (path) {
          var bread = this.$store.getters.breadcrumbs(path);
          return bread;
        } else {
          return [];
        }
      } else {
        return [];
      }
    }
  })
});

/***/ }),

/***/ "MOvk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MYir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N6Uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallDotName: 'flower-spinner-small-dot-' + Date.now(),
      bigDotName: 'flower-spinner-big-dot-' + Date.now()
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.smallDotName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.bigDotName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.smallDotName);
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.bigDotName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.smallDotName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.smallDotName, this.generateSmallDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.bigDotName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.bigDotName, this.generateBigDotKeyframes());
    },
    generateSmallDotKeyframes: function generateSmallDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    },
    generateBigDotKeyframes: function generateBigDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                50% {\n                  transform: rotate(180deg);\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  transform: rotate(360deg);\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    }
  }
});

/***/ }),

/***/ "NHch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuestic_theme_vuestic_plugin__ = __webpack_require__("2Nev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__("mWYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_parse__ = __webpack_require__("Gi9x");











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuestic_theme_vuestic_plugin__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate___default.a, { fieldsBagName: 'formFields' });

Object(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

var mediaHandler = function mediaHandler() {
  if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.config.windowMatchSizeLg).matches) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toggleSidebar', true);
  } else {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('toggleSidebar', false);
  }
};

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setLoading', true);
  var u = __WEBPACK_IMPORTED_MODULE_8__services_parse__["a" /* default */].User.current();
  var isLogged = false;
  if (u != null) {
    isLogged = true;
  }
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('isLogged', isLogged);
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.isLogged) {
      next();
    } else {
      console.log('need login', to);
      window.location.href = '/panel';
    }
  } else {
    next();
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].afterEach(function (to, from) {
  mediaHandler();
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setLoading', false);
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NPbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("3Alh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_aec4773e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("9MZa");
function injectStyle (ssrContext) {
  __webpack_require__("PhGI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aec4773e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_aec4773e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NpL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "NpMV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O3lU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__("mUJ2")("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),

/***/ "O5fT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var HORIZONTAL_LAYOUT = 'horizontal';
    var VERTICAL_LAYOUT = 'vertical';
    var initialLayout = binding.value.layout;
    var breakpoint = binding.value.breakPoint;

    var wizardLayout = initialLayout;

    var handleResize = function handleResize() {
      var width = window.innerWidth;
      var layout = width <= breakpoint ? HORIZONTAL_LAYOUT : VERTICAL_LAYOUT;
      if (wizardLayout !== layout) {
        wizardLayout = layout;
        vnode.context.$emit('wizardLayoutChange', wizardLayout);
      }
    };

    if (initialLayout === VERTICAL_LAYOUT) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
  }
});

/***/ }),

/***/ "OPFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__ = __webpack_require__("WHJM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_56dc4706_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__ = __webpack_require__("uLZf");
function injectStyle (ssrContext) {
  __webpack_require__("GoiS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56dc4706"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_56dc4706_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OX+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__ = __webpack_require__("UBQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__ = __webpack_require__("K82C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__ = __webpack_require__("PKk7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__ = __webpack_require__("1mf5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__ = __webpack_require__("O5fT");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard',
  props: {
    steps: {},
    wizardType: {
      type: String,
      default: 'simple'
    },
    wizardLayout: {
      type: String,
      default: 'horizontal'
    },
    lastStepLabel: { default: 'Confirm' },
    onNext: {},
    onBack: {}
  },
  data: function data() {
    return {
      currentStep: 0,
      wizardCompleted: false,
      wizardCompletedSlotName: 'wizardCompleted',
      orientationBreakPoint: 767,
      computedLayout: this.wizardLayout
    };
  },

  components: {
    SimpleHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__["a" /* default */],
    RichHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__["a" /* default */],
    RichVerticalIndicator: __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__["a" /* default */],
    SimpleVerticalIndicator: __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__["a" /* default */]
  },
  directives: {
    orientationHandler: __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__["a" /* default */]
  },
  computed: {
    currentSlot: function currentSlot() {
      var slotName = this.steps[this.currentStep].slot;
      if (this.wizardCompleted) {
        slotName = this.wizardCompletedSlotName;
      }
      return slotName;
    },
    backEnabled: function backEnabled() {
      return this.currentStep !== 0;
    }
  },
  created: function created() {
    this.$on('wizardLayoutChange', this.updateLayout);
  },

  methods: {
    updateLayout: function updateLayout(layout) {
      this.computedLayout = layout;
    },
    goNext: function goNext() {
      this.currentStepOnNext();
      if (!this.isLastStep() && this.isCurrentStepValid()) {
        this.currentStep++;
      }
    },
    goBack: function goBack() {
      this.currentStepOnBack();
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    completeWizard: function completeWizard() {
      this.wizardCompleted = true;
      this.goNext();
    },
    isLastStep: function isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    currentStepOnNext: function currentStepOnNext() {
      var step = this.steps[this.currentStep];
      if (step.onNext) {
        step.onNext();
      }
    },
    currentStepOnBack: function currentStepOnBack() {
      var step = this.steps[this.currentStep];
      if (step.onBack) {
        step.onBack();
      }
    },
    isCurrentStepValid: function isCurrentStepValid() {
      return this.steps[this.currentStep].isValid();
    },
    isStepShown: function isStepShown(step) {
      return step.slot === this.currentSlot && !this.wizardCompleted;
    }
  }
});

/***/ }),

/***/ "OjEM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"orientation-handler",rawName:"v-orientation-handler",value:({ layout: _vm.wizardLayout,  breakPoint: _vm.orientationBreakPoint }),expression:"{ layout: wizardLayout,  breakPoint: orientationBreakPoint }"}],staticClass:"wizard",class:_vm.computedLayout},[(_vm.computedLayout === 'horizontal')?_c('div',{staticClass:"indicator-container indicator-container-horizontal"},[(_vm.wizardType === 'simple')?_c('simple-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'rich')?_c('rich-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.computedLayout === 'vertical')?_c('div',{staticClass:"indicator-container indicator-container-vertical"},[(_vm.wizardType === 'rich')?_c('rich-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'simple')?_c('simple-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wizard-body"},[_vm._l((_vm.steps),function(step){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isStepShown(step)),expression:"isStepShown(step)"}],staticClass:"wizard-body-step"},[_vm._t(step.slot)],2)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.wizardCompleted),expression:"wizardCompleted"}],staticClass:"wizard-body-step"},[_vm._t(_vm.wizardCompletedSlotName)],2),_vm._v(" "),(!_vm.wizardCompleted)?_c('div',{staticClass:"wizard-body-actions"},[(_vm.backEnabled)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-secondary wizard-back pull-left",on:{"click":function($event){_vm.goBack()}}},[_vm._v("\n          Back\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.isLastStep())?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right",on:{"click":function($event){_vm.goNext()}}},[_vm._v("\n          Next\n        ")])]):_vm._e(),_vm._v(" "),(_vm.currentStep == _vm.steps.length - 1)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right final-step",on:{"click":function($event){_vm.completeWizard()}}},[_vm._v("\n          "+_vm._s(_vm.lastStepLabel)+"\n        ")])]):_vm._e()]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Omos":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P+0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor__ = __webpack_require__("kLCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_medium_editor__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-medium-editor',

  props: {
    editorOptions: {
      type: Object,
      default: function _default() {
        return {
          buttonLabels: 'fontawesome',
          autoLink: true,
          toolbar: {
            buttons: ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3']
          }
        };
      }
    }
  },

  data: function data() {
    return {
      editor: null
    };
  },
  mounted: function mounted() {
    this.initEditor();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyEditor();
  },


  methods: {
    initEditor: function initEditor() {
      this.editor = new __WEBPACK_IMPORTED_MODULE_0_medium_editor___default.a(this.$el, this.editorOptions);
      this.$emit('initialized', this.editor);
    },
    destroyEditor: function destroyEditor() {
      this.editor.destroy();
    }
  }
});

/***/ }),

/***/ "PB0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breeding-rhombus-spinner",style:(_vm.spinnerStyle)},[_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{key:index,staticClass:"rhombus",class:("child-" + (index + 1)),style:(rs)})}),_vm._v(" "),_c('div',{staticClass:"rhombus big",style:(_vm.bigRhombusStyle)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PGBW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)},[_c('div',{staticClass:"circle-inner-container",style:(_vm.circleInnerContainerStyle)},[_c('div',{staticClass:"circle-inner",style:(_vm.circleInnerStyle)})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PKk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__ = __webpack_require__("+tWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b85552d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__ = __webpack_require__("cWH0");
function injectStyle (ssrContext) {
  __webpack_require__("Q6mk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b85552d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b85552d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PhGI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q6mk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QI9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("oK+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fbcdc56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("X3IB");
function injectStyle (ssrContext) {
  __webpack_require__("qoIK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fbcdc56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QYFS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QtwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'employees',
  path: '/config-employees',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/EmployeesList'),
  meta: {
    default: false,
    title: 'Empleados',
    iconClass: 'vuestic-icon vuestic-icon-user',
    expanded: false
  }
});

/***/ }),

/***/ "RLg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__ = __webpack_require__("VLQC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3dc945ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__ = __webpack_require__("z4eX");
function injectStyle (ssrContext) {
  __webpack_require__("Ufqr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3dc945ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3dc945ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RYaB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RfGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-medium-editor"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SmvZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T1/M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T7Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("+s3s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0aa0ee74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("PB0M");
function injectStyle (ssrContext) {
  __webpack_require__("ubP3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0aa0ee74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0aa0ee74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TVMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__ = __webpack_require__("Z5WX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1eef53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__ = __webpack_require__("zKJh");
function injectStyle (ssrContext) {
  __webpack_require__("RYaB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1eef53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TqEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),

/***/ "U2Zt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var ddToggle = el.querySelector('.dropdown-toggle');
    var ddMenu = el.querySelector('.dropdown-menu');
    var closeOnMenuClick = binding.modifiers.closeOnMenuClick;

    ddToggle.addEventListener('click', function (evt) {
      evt.preventDefault();
      var isShown = el.classList.contains('show');
      setTimeout(function () {
        el.classList.toggle('show', !isShown);
        ddMenu.classList.toggle('show', !isShown);
      });
    });

    window.addEventListener('click', function () {
      el.classList.remove('show');
      ddMenu.classList.remove('show');
    });

    ddMenu.addEventListener('click', function (evt) {
      if (!closeOnMenuClick) {
        evt.stopPropagation();
      }
    });
  }
});

/***/ }),

/***/ "UA7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UBQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("IQ8j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13cde4a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("MYir");
function injectStyle (ssrContext) {
  __webpack_require__("XYgs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13cde4a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13cde4a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UW5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__ = __webpack_require__("H65f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ea30a568_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__ = __webpack_require__("PGBW");
function injectStyle (ssrContext) {
  __webpack_require__("19/3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea30a568"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ea30a568_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UeKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datatable_components_SimpleFilter_vue__ = __webpack_require__("vbwr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datatable_components_ItemsPerPage_vue__ = __webpack_require__("evu/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__ = __webpack_require__("7qYU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuestic_datatable_data_data_table_styles__ = __webpack_require__("KMiR");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-simple-table',
  components: {
    SimpleFilter: __WEBPACK_IMPORTED_MODULE_5__datatable_components_SimpleFilter_vue__["a" /* default */],
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_6__datatable_components_ItemsPerPage_vue__["a" /* default */]
  },
  props: {
    apiUrl: {
      type: String
    },
    download: {
      type: Function,
      default: null
    },
    httpFetch: {
      type: Function,
      default: null
    },
    onChangePage: {
      type: Function,
      default: function _default(p) {
        console.log('Default Page', p);
      }
    },
    onFind: {
      type: Function,
      default: function _default(t, m) {
        console.log('onFind', t, m);
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {}
    },
    filterQuery: {
      type: String,
      default: 'filter'
    },
    tableFields: {
      type: Array,
      required: true
    },
    filterFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemsPerPage: {
      type: Array,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage;
      }
    },
    perPageSelectorShown: {
      type: Boolean,
      default: true
    },
    headerShown: {
      type: Boolean,
      default: true
    },
    filterInputShown: {
      type: Boolean,
      default: true
    },
    loaded: {
      type: Boolean,
      default: true
    },
    defaultPerPage: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage[0].value
    },
    onEachSide: {
      type: Number,
      default: 2
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Object,
      default: function _default() {
        return {
          data: []
        };
      }
    },
    dataModeFilterableFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: ''
    },
    date: {
      type: Object
    },
    filterText: {
      type: String,
      default: ''
    },
    selectedField: {
      type: Object
    }
  },
  data: function data() {
    return {
      perPage: 0,
      colorClasses: {},
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_9__vuestic_datatable_data_data_table_styles__["a" /* default */]
    };
  },

  computed: {
    controlsAlignmentClass: function controlsAlignmentClass() {
      return {
        'justify-content-md-between': this.filterInputShown,
        'justify-content-md-end': !this.filterInputShown
      };
    },
    moreParams: function moreParams() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, this.filterQuery, this.filterText);
    },
    dataModeFilterableFieldsComputed: function dataModeFilterableFieldsComputed() {
      var dataItem = this.tableData.data[0] || {};
      var filterableFields = this.dataModeFilterableFields;

      if (!filterableFields.length) {
        var itemFields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataItem);
        itemFields.forEach(function (field) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(dataItem[field]) !== 'object') {
            filterableFields.push(field);
          }
        });
      }

      return filterableFields;
    },
    filteredTableData: function filteredTableData() {
      var _this = this;

      var txt = new RegExp(this.filterText, 'i');

      var filteredData = this.tableData.data.slice();

      filteredData = this.tableData.data.filter(function (item) {
        return _this.dataModeFilterableFieldsComputed.some(function (field) {
          var val = item[field] + '';
          return val.search(txt) >= 0;
        });
      });

      return {
        data: filteredData
      };
    },
    defaultPerPageComputed: function defaultPerPageComputed() {
      var defaultPerPage = __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage[0].value;

      if (this.$options.propsData.defaultPerPage) {
        defaultPerPage = this.$options.propsData.defaultPerPage;
      } else if (this.$options.propsData.itemsPerPage) {
        defaultPerPage = this.$options.propsData.itemsPerPage[0].value;
      }

      return defaultPerPage;
    },
    paginationPathComputed: function paginationPathComputed() {
      return this.apiMode ? this.paginationPath : 'pagination';
    }
  },

  created: function created() {
    this.perPage = this.defaultPerPageComputed;
  },


  methods: {
    onFilterSet: function onFilterSet(filterText) {
      var _this2 = this;

      console.log('FilterSET', filterText);
      this.filterText = filterText;
      __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this3 = this;

      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    defaultOnChangePage: function defaultOnChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.filteredTableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === 'desc') {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "Ufqr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuItems", function() { return menuItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleWithoutAnimation", function() { return toggleWithoutAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebarOpened", function() { return sidebarOpened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "palette", function() { return palette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "breadcrumbs", function() { return breadcrumbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogged", function() { return isLogged; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_utils__ = __webpack_require__("hLWQ");


var menuItems = function menuItems(state) {
  return state.menu.items;
};
var sidebarOpened = function sidebarOpened(state) {
  return state.app.sidebar.opened;
};
var toggleWithoutAnimation = function toggleWithoutAnimation(state) {
  return state.app.sidebar.withoutAnimation;
};
var config = function config(state) {
  return state.app.config;
};
var palette = function palette(state) {
  return state.app.config.palette;
};
var isLoading = function isLoading(state) {
  return state.app.isLoading;
};
var breadcrumbs = function breadcrumbs(state) {
  return function (keyword) {
    return __WEBPACK_IMPORTED_MODULE_0_services_utils__["a" /* default */].findInNestedByName(state.menu.items, keyword);
  };
};
var isLogged = function isLogged(state) {
  return state.app.isLogged;
};



/***/ }),

/***/ "UpdR":
/***/ (function(module, exports) {

module.exports = {"auth":{"agree":"I agree to","alreadyJoined":"Already joined?","createAccount":"Create account","createNewAccount":"Create account","email":"Email","login":"Login","password":"Password","signUp":"Sign Up","termsOfUse":"Terms of Use.","welcome":"Welcome!"},"breadcrumbs":{"home":"Home"},"buttons":{"advanced":"Icons, Groups, Dropdowns","button":"BUTTON","colors":"Colors","disabled":"DISABLED","dropdown":"DROPDOWN","hover":"HOVER","main":"Primary & Secondary Buttons","micro":"MICRO","pressed":"PRESSED","small":"SMALL"},"charts":{"horizontalBarChart":"Horizontal Bar Chart","verticalBarChart":"Vertical Bar Chart","lineChart":"Line Chart","pieChart":"Pie Chart","donutChart":"Donut Chart","bubbleChart":"Bubble Chart"},"dashboard":{"dataVisualization":"Data Visualization","success":"SUCCESS","successMessage":"You successfully read this important alert message.","elements":"Elements","features":"Features","setupProfile":"Setup Profile","teamMembers":"Team Members","usersAndMembers":"Users & Members","versions":"Versions"},"notificationsPage":{"alerts":{"title":"Alerts","success":"SUCCESS","successMessage":"You successfully read this important alert message.","info":"INFO","infoMessage":"This alert needs your attention, but it's not super important.","warning":"WARNING","warningMessage":"Better check yourself, you're not looking too good.","danger":"DANGER","dangerMessage":"Change a few things up and try submitting again."},"popovers":{"title":"Tooltips & Popovers","popoverTitleLabel":"Popover Title","popoverTextLabel":"Popover Text","popoverIconLabel":"Popover Icon (fontawesome)","showPopover":"Show Popover","topTooltip":"top tooltip","rightTooltip":"rightside tooltip","leftTooltip":"left","bottomTooltip":"below"},"toasts":{"title":"Toasts","textLabel":"Text","durationLabel":"Duration (milliseconds)","iconLabel":"Icon (fontawesome)","fullWidthLabel":"Fullwidth","launchToast":"Launch toast"}},"extra":{"tabs":{"title":"Tabs","maps":"Maps","overview":"Overview","setupProfile":"Setup Profile"},"chat":"Chat","profileCard":"Profile Card"},"forms":{"controls":{"female":"Female","male":"Male","title":"Checkboxes, Radios, Switches","radioDisabled":"Disabled Radio","radio":"Radio","subscribe":"Subscribe to newsletter"},"inputs":{"emailValidatedSuccess":"Email (validated with success)","emailValidated":"Email (validated)","inputWithIcon":"Input With Icon","inputWithButton":"Input With Button","inputWithClearButton":"Input With Clear Button","inputWithRoundButton":"Input With Round Button","textInput":"Text Input","textInputWithDescription":"Text Input (with description)","textArea":"Text Area","title":"Inputs","upload":"UPLOAD"},"mediumEditor":{"title":"Medium Editor"},"selects":{"country":"Country Select","countryMulti":"Country Multi Select","multi":"Multi Select","simple":"Simple Select","title":"Selects"},"wizard":{"name":"Name","completed":"Wizard completed!","confirmSelection":"Confirm selection","rich":"Rich Wizard","simple":"Simple Wizard","stepOne":"Step 1. Name","stepTwo":"Step 2. Country","stepThree":"Step 3. Confirm","verticalRich":"Vertical Rich Wizard","verticalSimple":"Vertical Simple Wizard"}},"grid":{"desktop":"Desktop Grid","fixed":"Fixed Grid","offsets":"Offsets","responsive":"Responsive Grid"},"icons":{"back":"Back to icons","none":"No icons found","search":"Icon search","title":"Icons"},"spinners":{"title":"Spinners","poweredBy":"Powered by"},"language":{"english":"English","spanish":"Spanish"},"menu":{"drivers":"Conductores","cars":"Carros","auth":"Auth","buttons":"Buttons","charts":"Charts","dashboard":"Dashboard","extra":"Extra","formElements":"Form Elements","forms":"Forms","formWizards":"Form Wizards","mediumEditor":"Medium Editor","grid":"Grid","icons":"Icons","spinners":"Spinners","login":"Login","maps":"Maps","modals":"Modals","notifications":"Notifications","progressBars":"Progress Bars","signUp":"Sign up","statistics":"Statistics","tables":"Tables","typography":"Typography","uiElements":"UI Elements","treeView":"Tree view"},"messages":{"all":"See all messages","new":"New messages from {name}"},"modal":{"cancel":"CANCEL","close":"CLOSE","confirm":"CONFIRM","large":"Large","largeTitle":"Large Modal","medium":"Medium","mediumTitle":"Medium Modal","small":"Small","smallTitle":"Small Modal","static":"Static","staticMessage":"This is a static modal, backdrop click will not close it.","staticTitle":"Static Modal","title":"Modals"},"navbar":{"messageUs":"Send us your questions or feedback to"},"notifications":{"all":"See all notifications","sentMessage":"{name} sent you a message","uploadedZip":"{name} uploaded a new Zip file with {type}","startedTopic":"{name} started a new topic"},"progressBars":{"basic":"Basic","basicVertical":"Basic Vertical","circle":"Circle","colorFulTitle":"Colorful Bars","thin":"Thin","thinVertical":"Thin Vertical","thick":"Thick","title":"Progress Bars"},"tables":{"basic":"Basic Table","styled":"Colors, Icons, Labels","advanced":"Search & Pagination","headings":{"city":"City","email":"Email","name":"Name","score":"Score"}},"user":{"language":"Change Language","logout":"Logout","profile":"My Profile"},"treeView":{"basic":"Basic","icons":"Icons","selectable":"Selectable","editable":"Editable","advanced":"Advanced"}}

/***/ }),

/***/ "V8nc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hollow-dots-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.dotsStyles),function(ds,index){return _c('div',{key:index,staticClass:"dot",style:(ds)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VKe+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VLQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "VVeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_parse__ = __webpack_require__("Gi9x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_expanding_src_Expanding__ = __webpack_require__("OPFe");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var user, query, result, array, array2, queryH, count;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              user = __WEBPACK_IMPORTED_MODULE_3_services_parse__["a" /* default */].User.current();

              if (!(!this.flag && user)) {
                _context.next = 21;
                break;
              }

              query = new __WEBPACK_IMPORTED_MODULE_3_services_parse__["a" /* default */].Query(__WEBPACK_IMPORTED_MODULE_3_services_parse__["a" /* default */].User);

              query.include('permissions');
              _context.next = 6;
              return query.get(user.id);

            case 6:
              result = _context.sent;
              array = result.get('permissions') ? result.get('permissions').get('modules') : [];
              array2 = result.get('permissions') ? result.get('permissions').get('modules2') : { modules: [], childs: [] };
              queryH = new __WEBPACK_IMPORTED_MODULE_3_services_parse__["a" /* default */].Query('Holder2');

              queryH.equalTo('user', user);
              _context.next = 13;
              return queryH.count();

            case 13:
              count = _context.sent;

              console.log('count2', count);
              console.log('array', array, 'array2', array2);
              if (count > 0) {
                array.push('holder');
              }
              if (user.get('supervisor')) {
                array.push('supervisor');
              }

              this.access = array;
              this.flag = true;
              console.log('array', array, 'array2', array2);

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_expanding_src_Expanding__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    expand: 'toggleExpandMenuItem'
  }), {
    toggleMenuItem: function toggleMenuItem(item) {
      if (item.children) {
        this.expand({
          menuItem: item,
          expand: !item.meta.expanded
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    'menuItems': 'menuItems'
  })),
  watch: {
    $route: function $route(route) {
      var _this = this;

      var parent = _findMatchingParentMenuItem.call(this, route.name) || {};
      this.menuItems.forEach(function (item) {
        _this.expand({
          menuItem: item,
          expand: parent.name === item.name
        });
      });
    }
  },
  data: function data() {
    return {
      show: false,
      access: { modules: [], childs: [] },
      flag: false
    };
  }
});

function _findMatchingParentMenuItem(itemName) {
  var parentItem = void 0;

  this.menuItems.forEach(function (item) {
    parentItem = item.children && item.children.find(function (child) {
      return child.name === itemName;
    }) ? item : parentItem;
  });

  return parentItem;
}

/***/ }),

/***/ "Vj97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vliu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-root"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VoWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__ = __webpack_require__("s+US");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_828d929a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__ = __webpack_require__("g6j3");
function injectStyle (ssrContext) {
  __webpack_require__("i2v5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_828d929a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VwpK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W3ZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__ = __webpack_require__("oKE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30772e88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__ = __webpack_require__("FiBV");
function injectStyle (ssrContext) {
  __webpack_require__("MOvk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30772e88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WHJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),

/***/ "WHs2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fingerprint-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"spinner-ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WO+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WO5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"language-selector dropdown"},[_c('a',{staticClass:"language-selector-button dropdown-toggle",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}},[_c('i',{staticClass:"flag-icon flag-icon-large",class:_vm.flagIconClass(_vm.currentLanguage())})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},_vm._l((_vm.options),function(option,id){return _c('a',{key:id,staticClass:"dropdown-item",class:{ active: option.code === _vm.currentLanguage() },on:{"click":function($event){_vm.setLanguage(option.code)}}},[_c('i',{staticClass:"flag-icon flag-icon-small",class:_vm.flagIconClass(option.code)}),_vm._v(" "),_c('span',{staticClass:"dropdown-item-text ellipsis"},[_vm._v("\n        "+_vm._s(_vm._f("translate")(("language." + (option.name))))+"\n      ")])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WOMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Doughnut"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var state = {
  sidebar: {
    opened: false,
    withoutAnimation: false
  },
  config: {
    googleMaps: {
      apiKey: 'AIzaSyDFE5IMF4suAO1lsHSrbnFaKs6l1dBljXc'
    },
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd'
    }
  },
  isLoading: true,
  isLogged: false
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */], function (state) {
  if (document.documentElement.clientWidth < 992) {
    state.sidebar.opened = false;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_SIDEBAR */], function (state, opened) {
  state.sidebar.opened = opened;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* TOGGLE_WITHOUT_ANIMATION */], function (state, value) {
  state.sidebar.withoutAnimation = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'setLoading', function setLoading(state, isLoading) {
  state.isLoading = isLoading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'isLogged', function isLogged(state, value) {
  state.isLogged = value;
}), _mutations);

var actions = {
  closeMenu: function closeMenu(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLOSE_MENU */]);
  },
  toggleSidebar: function toggleSidebar(_ref2, opened) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* TOGGLE_SIDEBAR */], opened);
  },
  isToggleWithoutAnimation: function isToggleWithoutAnimation(_ref3, value) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* TOGGLE_WITHOUT_ANIMATION */], value);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "WXh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__ = __webpack_require__("3VgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c937b99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__ = __webpack_require__("mdWz");
function injectStyle (ssrContext) {
  __webpack_require__("VKe+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c937b99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WlTu":
/***/ (function(module, exports) {

module.exports = {"auth":{"agree":"Acepto","alreadyJoined":"Ya tienes una cuenta?","createAccount":"Create cuenta","createNewAccount":"Crear cuenta","email":"Email","login":"Iniciar sesión","password":"Contraseña","signUp":"Registrar","termsOfUse":"Los terminos de uso","welcome":"Bienvenido!"},"buttons":{"advanced":"Iconos, Grupos, Dropdowns","button":"BOTON","colors":"Colores","disabled":"DESHABILITADO","dropdown":"DESPLEGABLE","hover":"HOVER","main":"Botón Primario y Secundario","micro":"MICRO","pressed":"PRESIONADO","small":"PEQUEÑO"},"charts":{"bubbleChart":"Bubble Chart","donutChart":"Donut Chart","horizontalBarChart":"Horizontal Bar Chart","lineChart":"Line Chart","pieChart":"Pie Chart","verticalBarChart":"Vertical Bar Chart"},"dashboard":{"elements":"Elementos","success":"ÉXITO","successMessage":"Ha leído correctamente este mensaje de alerta importante.","teamMembers":"Miembros del Equipo","versions":"Versiones"},"notificationsPage":{"alerts":{"title":"Alerts","success":"ÉXITO","successMessage":"Ha leído correctamente este mensaje de alerta importante.","info":"INFO","infoMessage":"Esta alerta necesita tu atención, pero no es muy importante.","warning":"ADVERTENCIA","warningMessage":"Mejor compruébalo, esto no pinta bien.","danger":"PELIGRO","dangerMessage":"Cambiar algunas cosas e enviarlo de nuevo."},"popovers":{"title":"Tooltips & Popovers","popoverTitleLabel":"Title de Popover","popoverTextLabel":"Texto de Popover","popoverIconLabel":"Icono de Popover (fontawesome)","showPopover":"Mostrar Popover","topTooltip":"tope tooltip","rightTooltip":"derecha tooltip","leftTooltip":"izquierda","bottomTooltip":"fondo"},"Toasts":{"title":"tostadas","textLabel":"Texto","durationLabel":"Duración (milisegundos)","iconLabel":"Icono (fontawesome)","fullWidthLabel":"Ancho total","launchToast":"Lanzar tostadas"}},"extra":{"tabs":{"title":"Tabs","maps":"Mapas","overview":"Visión de conjunto","setupProfile":"Perfil de Configuración"},"chat":"Chat","profileCard":"Tarjeta de Perfil"},"forms":{"controls":{"female":"Mujer","male":"Hombre","title":"Checkboxes, Radios, Switches","radioDisabled":"Radio Desactivado","radio":"Radio","subscribe":"Suscribirse a la newsletter"},"inputs":{"emailValidatedSuccess":"Email (validado con éxito)","emailValidated":"Email (validado)","inputWithIcon":"Input con Icono","inputWithButton":"Input con Boton","inputWithClearButton":"Input With Clear Button","inputWithRoundButton":"Input With Round Button","textInput":"Input de Texto","textInputWithDescription":"Input de Texto (con descripcion)","textArea":"Text Area","title":"Inputs","upload":"SUBIR"},"mediumEditor":{"title":"Medium Editor"},"selects":{"country":"País Select","countryMulti":"País Multi Select","multi":"Multi Select","simple":"Select Simple","title":"Selects"},"wizard":{"completed":"Asistente Completado!","confirmSelection":"Confirmar selección","name":"Nombre","rich":"Asistente Rico","simple":"Asistente Simple","stepOne":"Step 1. Nombre","stepTwo":"Step 2. País","stepThree":"Step 3. Confirmar","verticalRich":"Asistente Rico Vertical","verticalSimple":"Asistente Simple Vertical"}},"grid":{"fixed":"Grid Fijo","desktop":"Desktop Grid","responsive":"Responsive Grid","offsets":"Offsets"},"icons":{"back":"Volver a los iconos","none":"No se han encontrado iconos","search":"Búsqueda de iconos","title":"Iconos"},"language":{"english":"Ingles","spanish":"Español"},"menu":{"auth":"Autenticación","buttons":"Botones","drivers":"Conductores","cars":"Carros","charts":"Gráficos","dashboard":"Dashboard","extra":"Extra","formElements":"Elementos de un Formulario","forms":"Formularios","formWizards":"Asistente para Formularios","mediumEditor":"Medium Editor","grid":"Grid","icons":"Iconos","login":"Iniciar sesión","maps":"Mapas","modals":"Modals","notifications":"Notificaciones","progressBars":"Barras de Progreso","signUp":"Registrar","statistics":"Estadisticas","tables":"Tablas","typography":"Tipografía","uiElements":"Elementos UI"},"messages":{"all":"Ver todos los mensajes","new":"Nuevo mensajes de {name}"},"modal":{"cancel":"CANCELAR","close":"CERRAR","confirm":"CONFIRMAR","large":"Largo","largeTitle":"Modal Largo","medium":"Mediano","mediumTitle":"Modal Mediana","small":"Pequeño","static":"Estático","smallTitle":"Modal Pequeña","staticMessage":"Esto es un modal estático. No se cerrará haciendo clic en el fondo.","staticTitle":"Modal Estático","title":"Modals"},"navbar":{"messageUs":"Envíenos sus preguntas o comentarios a"},"notifications":{"all":"Ver todos los notificaciones","sentMessage":"{name} te ha mandado un mensaje","uploadedZip":"{name} ha subido un archivo Zip con {type}","startedTopic":"{name} ha creado una tema nueva"},"progressBars":{"basic":"Basico","basicVertical":"Basico y Vertical","circle":"Circular","colorFulTitle":"Barras Coloridas","thin":"Delgado","thinVertical":"Delgado Vertical","thick":"Grueso","title":"Barras de Progresso"},"tables":{"basic":"Tabla basica","styled":"Colores, Iconos, Etiquetas","advanced":"Búsqueda y Paginación","headings":{"city":"Ciudad","email":"Email","name":"Nombre","score":"Puntuación"}},"user":{"language":"Cambiar Idioma","profile":"Mi Perfil","logout":"Cerrar Sesión"}}

/***/ }),

/***/ "Wzot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__ = __webpack_require__("N6Uh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f2020216_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__ = __webpack_require__("c8rA");
function injectStyle (ssrContext) {
  __webpack_require__("fcTP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2020216"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f2020216_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X3IB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar app-navbar navbar-toggleable-md"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row navbar-container"},[_c('div',{staticClass:"menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col"},[(_vm.sidebarOpened)?_c('a',{staticClass:"menu-icon i-menu-expanded",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebar(false)}}}):_c('a',{staticClass:"menu-icon i-menu-collapsed",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebar(true)}}})]),_vm._v(" "),_c('div',{staticClass:"navbar-text offset-md-1 col-md-7 d-none d-lg-flex align-items-center justify-content-center"}),_vm._v(" "),_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-menu-content"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.$t('messages.new', {name: "Oleg M"})))])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.$t('messages.new', {name: "Andrei H"})))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm._f("translate")('messages.all')))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('div',{staticClass:"dropdown-menu-content"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.$t('notifications.sentMessage', {name: 'Vasily S'})))])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.$t('notifications.uploadedZip', { name: "Oleg M", type: "typography component"})))])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.$t('notifications.startedTopic',{name: "Andrei H"})))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm._f("translate")('notifications.all')))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-right justify-content-right"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("\n          "+_vm._s(_vm.username)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu last"},[_c('div',{staticClass:"dropdown-menu-content"},[_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",attrs:{"href":"#"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Cerrar Sesión")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-brand-container d-flex align-items-center justify-content-start"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#/dashboard"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar-container"},[_c('img',{attrs:{"src":__webpack_require__("fb+g")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X5DT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"nav d-lg-none"},[_c('router-link',{staticClass:"i-vuestic",attrs:{"to":{path: '/'}}})],1),_vm._v(" "),_c('div',{staticClass:"main row"},[_c('div',{staticClass:"auth-content col-lg-6 col-12"},[_c('router-view')],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-wallpaper col-6 d-none d-lg-flex"},[_c('img',{staticClass:"img-logo",attrs:{"src":__webpack_require__("fb+g")}}),_vm._v(" "),_c('div',{})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"made-by-footer"},[_vm._v("\n    Información y ayuda   "),_c('strong',[_vm._v("soporte.tecnico@aircab.mx")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XGsO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XYgs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[(_vm.showFilter)?_c('vuestic-simple-select',{attrs:{"label":"Campo","option-key":"description","options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.showFilter)?_c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],attrs:{"id":"input-icon-left","name":"input-icon-left","required":""},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v("Comienza con")]),_c('i',{staticClass:"bar"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.date)?_c('datetime',{staticStyle:{"width":"100%","text-align":"center"},attrs:{"value-zone":"UTC","zone":"UTC"},model:{value:(_vm.formatDate),callback:function ($$v) {_vm.formatDate=$$v},expression:"formatDate"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"id":"itemsPerPageBtn","type":"button"},on:{"click":function($event){_vm.doFilter()}}},[_vm._v("\n      Buscar\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xdnb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleTable_vue__ = __webpack_require__("UeKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6883a7ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleTable_vue__ = __webpack_require__("bV2l");
function injectStyle (ssrContext) {
  __webpack_require__("7aGr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6883a7ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y+KL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__ = __webpack_require__("r/aY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba2a7b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__ = __webpack_require__("kZD4");
function injectStyle (ssrContext) {
  __webpack_require__("yqnu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba2a7b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y9RQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-building-square-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:{'clear': index && index % 3 === 0},style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YHML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__ = __webpack_require__("2u3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b5031426_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__ = __webpack_require__("dAEi");
function injectStyle (ssrContext) {
  __webpack_require__("HKGv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5031426"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b5031426_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YIC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driverCard2',
  meta: {
    expanded: false,
    title: 'TARJETON',
    iconClass: 'vuestic-icon vuestic-icon-auth',
    isShareTrip: true
  },
  children: [{
    name: 'driverCard',
    path: '/p/:driverId',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverCard'),
    meta: {
      title: 'Tarjeton',
      requiresAuth: false,
      isShareTrip: true
    }
  }]
});

/***/ }),

/***/ "YMqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__ = __webpack_require__("U2Zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("Y+KL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-simple-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["a" /* default */]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    options: Array,
    value: {},
    optionKey: String,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'simple-select'
    }
  },
  mounted: function mounted() {
    this.updateDisplayValue(this.value);
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    isOptionSelected: function isOptionSelected(option) {
      return this.value === option;
    },
    selectOption: function selectOption(option) {
      this.updateDisplayValue(option);
      this.$emit('input', option);
    },
    updateDisplayValue: function updateDisplayValue(val) {
      this.displayValue = this.optionKey ? val[this.optionKey] : val;
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "YPsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-switch',
  props: {
    value: Boolean
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },

  methods: {
    setValue: function setValue(newVal) {
      this.$emit('input', newVal);
    }
  }
});

/***/ }),

/***/ "YROu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SquareWithIcon_vue__ = __webpack_require__("eOeK");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SquareWithIcon: __WEBPACK_IMPORTED_MODULE_0__SquareWithIcon_vue__["a" /* default */] }
});

/***/ }),

/***/ "YUx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("zkRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7b1a47f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("gkKA");
function injectStyle (ssrContext) {
  __webpack_require__("BFrm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b1a47f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7b1a47f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YZN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-square-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__ = __webpack_require__("ZEli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_store_modules_menu_lazyLoading__ = __webpack_require__("O3lU");







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var demoRoutes = [];
if (true) {
  var VueComponentTree = __webpack_require__("v65x");

  demoRoutes.push(VueComponentTree.default(__webpack_require__("hBvJ"), '/demo'));
}

var hiddenRoutes = [{
  name: 'padronPushHistory',
  path: '/push-history',
  component: Object(__WEBPACK_IMPORTED_MODULE_4_vuex_store_modules_menu_lazyLoading__["a" /* default */])('config/PushHistory'),
  meta: { title: 'Historial Push', requiresAuth: true }
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [].concat(demoRoutes, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__["a" /* default */].state.items)), hiddenRoutes, [{
    path: '*',
    redirect: { name: getDefaultRoute(__WEBPACK_IMPORTED_MODULE_3_vuex_store_modules_menu__["a" /* default */].state.items).name }
  }])
}));

function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

function getDefaultRoute() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var defaultRoute = void 0;

  menu.forEach(function (item) {
    if (item.meta.default) {
      defaultRoute = item;
    } else if (item.children) {
      var defaultChild = item.children.find(function (i) {
        return i.meta.default;
      });
      defaultRoute = defaultChild || defaultRoute;
    }
  });

  return defaultRoute;
}

/***/ }),

/***/ "YeH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("l92n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0eabb6d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("uMWB");
function injectStyle (ssrContext) {
  __webpack_require__("1/u9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eabb6d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0eabb6d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yiyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square-with-icon"},[_c('span',{staticClass:"icon"},[_c('i',{class:_vm.iconClass,attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z5WX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-widget',

  props: ['headerText']
});

/***/ }),

/***/ "Z6hS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-node',
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "Z9/R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZEli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard__ = __webpack_require__("Bueh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manualInvoice__ = __webpack_require__("nEss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__("fAOU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tools__ = __webpack_require__("u5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__monitor__ = __webpack_require__("IJwp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tickets__ = __webpack_require__("67bY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ticketsBasic__ = __webpack_require__("eVB8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__trips__ = __webpack_require__("lR6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tripsBasic__ = __webpack_require__("e3q2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__("ff/G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__admin__ = __webpack_require__("DAzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sharedTrip__ = __webpack_require__("9NO8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__test__ = __webpack_require__("BmEH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__padron__ = __webpack_require__("ymQ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__padronBasic__ = __webpack_require__("zdOw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__padronAICM__ = __webpack_require__("0Zxf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__employees__ = __webpack_require__("QtwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__driverCard__ = __webpack_require__("ImtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__driverCard2__ = __webpack_require__("YIC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__owner__ = __webpack_require__("oiPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__support__ = __webpack_require__("vnff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__aircabReport__ = __webpack_require__("8uvc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__callCenter__ = __webpack_require__("wIuh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__supervisor__ = __webpack_require__("Jo31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__holder__ = __webpack_require__("jdTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__finanzaporto__ = __webpack_require__("2+uQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__driverPagos__ = __webpack_require__("pDEH");



































var state = {
  items: [__WEBPACK_IMPORTED_MODULE_21__owner__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__driverCard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__driverCard2__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__monitor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__trips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__tripsBasic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__tickets__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__ticketsBasic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__manualInvoice__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__padron__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__padronBasic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__padronAICM__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__aircabReport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__callCenter__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__employees__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__tools__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__support__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__test__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__admin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__sharedTrip__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__driverPagos__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__supervisor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__holder__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__finanzaporto__["a" /* default */]]
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_EXPAND_MENU_ITEM */], function (state, payload) {
  var menuItem = payload.menuItem;
  var expand = payload.expand;
  if (menuItem.children && menuItem.meta) {
    menuItem.meta.expanded = expand;
  }
});

var actions = {
  toggleExpandMenuItem: function toggleExpandMenuItem(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* TOGGLE_EXPAND_MENU_ITEM */], payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "ZXLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"left":"420px","top":"180px","background-color":"white","position":"absolute"}},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.$refs.treeView.expand()}}},[_vm._v("\n    EXPAND ALL\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.$refs.treeView.collapse()}}},[_vm._v("\n    COLLAPSE ALL\n  ")]),_vm._v(" "),_c('vuestic-tree-root',{ref:"treeView"},[_c('vuestic-tree-category',{attrs:{"label":"Category text","isOpen":""}},[_c('vuestic-tree-node',[_vm._v("\n        Node text\n      ")]),_vm._v(" "),_c('vuestic-tree-node',[_vm._v("\n        Node text\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZoX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'pixel-spinner-animation-' + Date.now()
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                      ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                      0 ' + this.pixelSize * -1.5 + 'px 0 0\n                    '
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n      50% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n\n      75% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n      100% {\n        transform: rotate(360deg);\n      }';
    }
  }
});

/***/ }),

/***/ "a13N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tablePagination && _vm.tablePagination.last_page > 1),expression:"tablePagination && tablePagination.last_page > 1"}],class:_vm.css.wrapperClass},[_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(1)}}},[(_vm.css.icons.first != '')?_c('i',{class:[_vm.css.icons.first]}):_c('span',[_vm._v("«")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('prev')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.prev]}):_c('span',[_vm._v(" ‹")])]),_vm._v(" "),(_vm.notEnoughPages)?[_vm._l((_vm.totalPage),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){_vm.loadPage(n)}}})]})]:[_vm._l((_vm.windowSize),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart+n-1) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){_vm.loadPage(_vm.windowStart+n-1)}}})]})],_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('next')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.next]}):_c('span',[_vm._v("› ")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(_vm.totalPage)}}},[(_vm.css.icons.last != '')?_c('i',{class:[_vm.css.icons.last]}):_c('span',[_vm._v("»")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aHv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__ = __webpack_require__("OX+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fdafe61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__ = __webpack_require__("OjEM");
function injectStyle (ssrContext) {
  __webpack_require__("T1/M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fdafe61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fdafe61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aN7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spring-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spring-spinner-part top",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})]),_vm._v(" "),_c('div',{staticClass:"spring-spinner-part bottom",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aaOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],class:_vm.classObject},[_c('navbar'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_c('main',{staticClass:"content",attrs:{"id":"content","role":"main"}},[_c('vuestic-breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('vuestic-pre-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],ref:"preLoader",staticClass:"pre-loader"}),_vm._v(" "),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bGbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationName: 'spring-spinner-animation-' + Date.now()
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.animationName
      };
    }
  },

  watch: {
    size: {
      handler: 'updateAnimation',
      immediate: true
    },
    color: {
      handler: 'updateAnimation',
      immediate: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
  },


  methods: {
    updateAnimation: function updateAnimation() {
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].removeKeyframes(this.animationName);
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.animationName, this.generateKeyframes());
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        0% {\n          border-width: ' + this.size / 7 + 'px;\n        }\n        25% {\n          border-width: ' + this.size / 23.33 + 'px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ' + this.size / 7 + 'px;\n        }\n        75% {\n          border-width: ' + this.size / 23.33 + 'px;\n         }\n        100% {\n         border-width: ' + this.size / 7 + 'px;\n        }';
    }
  }
});

/***/ }),

/***/ "bV2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-data-table"},[(_vm.loaded)?_c('div',[(_vm.headerShown)?_c('simple-filter',{attrs:{"onFind":_vm.onFind,"date":_vm.date,"filterText":_vm.filterText,"filterFields":_vm.filterFields,"selectedField":_vm.selectedField}}):_vm._e(),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"api-mode":false,"data":_vm.tableData,"fields":_vm.tableFields,"css":_vm.css.table,"dataPath":"data","paginationPath":_vm.paginationPathComputed,"appendParams":_vm.moreParams,"perPage":_vm.perPage},on:{"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),(_vm.download)?_c('button',{on:{"click":function($event){_vm.download()}}},[_vm._v("Descargar Reporte")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.loaded)?_c('div',[_vm._v("Cargando ...")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c8rA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flower-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"dots-container",style:(_vm.dotsContainerStyle)},[_c('div',{staticClass:"big-dot",style:(_vm.biggerDotStyle)},[_c('div',{staticClass:"small-dot",style:(_vm.smallerDotStyle)})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cLv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_demo_vue__ = __webpack_require__("1KK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0817a8c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_demo_vue__ = __webpack_require__("8P8v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeCategory_demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0817a8c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeCategory_demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cMCj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cPxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-line"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cSfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"popover-class":_vm.popoverClass,"open":_vm.open,"disabled":_vm.disabled,"placement":_vm.placement,"auto-hide":_vm.autoHide}},[_vm._t("trigger"),_vm._v(" "),_c('template',{attrs:{"slot":"popover"},slot:"popover"},[(_vm.isIconPresent)?_c('div',{staticClass:"popover-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popover-content"},[_c('div',{staticClass:"popover-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"popover-body"},[_vm._t("body")],2)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cWH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-md-checkmark step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dAEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle-1",style:(_vm.circle1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle-2",style:(_vm.circle2Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dG/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"left":"420px","top":"180px","background-color":"white","position":"absolute"}},[_c('vuestic-tree-node',[_c('vuestic-checkbox',{attrs:{"slot":"checkbox"},slot:"checkbox",model:{value:(_vm.checkboxValue),callback:function ($$v) {_vm.checkboxValue=$$v},expression:"checkboxValue"}}),_vm._v(" "),_c('div',{staticClass:"icon",attrs:{"slot":"icon"},slot:"icon"},[_c('span',{staticClass:"ion ion-md-nutrition",attrs:{"aria-hidden":"true"}})]),_vm._v("\n    Some text\n  ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dO+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden)?_c('div',{staticClass:"vuestic-alert alert",class:_vm.alertClass},[_vm._t("default"),_vm._v(" "),(_vm.withCloseBtn)?_c('i',{staticClass:"fa fa-close alert-close",on:{"click":function($event){_vm.hide()}}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dPe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


var palette = __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.palette;

/* harmony default export */ __webpack_exports__["a"] = ({
  legend: {
    position: 'bottom',
    labels: {
      fontColor: palette.fontColor,
      fontFamily: 'sans-serif',
      fontSize: 14,
      padding: 20,
      usePointStyle: true
    }
  },
  tooltips: {
    bodyFontSize: 14,
    bodyFontFamily: 'sans-serif'
  },
  responsive: true,
  maintainAspectRatio: false
});

/***/ }),

/***/ "dq31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__ = __webpack_require__("kl3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d3ea38d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__ = __webpack_require__("FRPd");
function injectStyle (ssrContext) {
  __webpack_require__("irRG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3ea38d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d3ea38d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e3q2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tripsBasic',
  meta: {
    expanded: false,
    title: 'Viajes',
    iconClass: 'fa fa-taxi'
  },
  children: [{
    path: '/trips/trip-finished',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/Main'),
    meta: {
      title: 'Viajes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/Finished'),
      meta: {
        title: 'Finalizado'
      }
    }, {
      name: 'tripView',
      path: ':travelId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/View'),
      props: true,
      meta: {
        title: 'Finalizado'
      }
    }]
  }]
});

/***/ }),

/***/ "eBYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__ = __webpack_require__("laTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6fb76137_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__ = __webpack_require__("V8nc");
function injectStyle (ssrContext) {
  __webpack_require__("NpMV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fb76137"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6fb76137_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eGfA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip__ = __webpack_require__("VN6J");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tooltip',

  directives: { tooltip: __WEBPACK_IMPORTED_MODULE_1_v_tooltip__["b" /* VTooltip */] },

  computed: {
    tooltipOptions: function tooltipOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultOptions, this.options);
    }
  },

  props: {
    options: {
      type: Object,
      default: {}
    }
  },

  data: function data() {
    return {
      defaultOptions: {
        classes: 'vuestic-tooltip'
      }
    };
  }
});

/***/ }),

/***/ "eJuD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eOeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__ = __webpack_require__("BcT4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f96825c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__ = __webpack_require__("Yiyg");
function injectStyle (ssrContext) {
  __webpack_require__("XGsO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SquareWithIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f96825c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SquareWithIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eVB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticketsBasic',
  meta: {
    expanded: false,
    title: 'Finanzas',
    iconClass: 'fa fa-money'
  },
  children: [{
    name: 'clarification-ticket',
    path: '/utils/clarification-ticket',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/AssignTicket'),
    meta: {
      title: 'Aclaración de Boletos',
      requiresAuth: true
    }
  }, {
    name: 'InvoiceList',
    path: '/invoices',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/invoices/InvoiceList'),
    meta: {
      title: 'Facturas Emitidas',
      requiresAuth: true
    }
  }, {
    path: '/financial/aircab-sales-company',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Aircab Venta'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('financial/Company/AircabList'),
      meta: {
        title: 'Lista Aircab'
      }
    }]
  }]
});

/***/ }),

/***/ "ehv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["HorizontalBar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "evu/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("10yw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_895fb6f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("68r5");
function injectStyle (ssrContext) {
  __webpack_require__("cMCj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-895fb6f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_895fb6f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f2UZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "f8CP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    large2: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'CONFIRM'
    },
    cancelText: {
      type: String,
      default: 'CANCEL'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary'
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg2': this.large2,
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    listenKeyUp: function listenKeyUp(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    },
    ok: function ok() {
      this.$emit('ok');
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.show = false;
      window.removeEventListener('keyup', this.listenKeyUp);
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
      window.addEventListener('keyup', this.listenKeyUp);
    }
  }
});

/***/ }),

/***/ "fAOU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth',
  meta: {
    expanded: false,
    title: 'menu.auth',
    iconClass: 'vuestic-icon vuestic-icon-auth'
  },
  children: [{
    name: 'menu.login',
    path: '/auth/login',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('auth/login/Login'),
    meta: {
      default: true,
      title: 'menu.login',
      newWindow: true
    }
  }, {
    name: 'menu.signUp',
    path: '/auth/signup',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('auth/signup/Signup'),
    meta: {
      default: false,
      title: 'menu.signUp',
      newWindow: true
    }
  }]
});

/***/ }),

/***/ "fB5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



var toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 2500
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_toasted___default.a, toastOptions);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showToast: function showToast(msg, options) {
      this.$toasted.show(msg, options);
    }
  }
});

/***/ }),

/***/ "fCLS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSelector_vue__ = __webpack_require__("x4Ng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fb395c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSelector_vue__ = __webpack_require__("WO5B");
function injectStyle (ssrContext) {
  __webpack_require__("ghUU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fb395c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fJoC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function generateRandomId() {
  return Math.floor(Math.random() * Math.pow(10, 10));
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-checkbox',
  props: {
    label: String,
    id: {
      type: String,
      default: function _default() {
        return 'label-' + generateRandomId();
      }
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    brandColor: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].indexOf(value) >= 0;
      }
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  mounted: function mounted() {
    this.$emit('change', this.checked);
  },

  methods: {
    onChange: function onChange(event) {
      this.$emit('change', event.target.checked);
    }
  },
  computed: {
    additionalClasses: function additionalClasses() {
      return [this.isCircle ? 'abc-checkbox-circle' : false, 'abc-checkbox-' + this.brandColor];
    }
  }
});

/***/ }),

/***/ "fPvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSlider_vue__ = __webpack_require__("j1c/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406908cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSlider_vue__ = __webpack_require__("lLPG");
function injectStyle (ssrContext) {
  __webpack_require__("Vj97")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406908cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fVS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{staticClass:"no-padding no-v-padding"},[_c('div',{staticClass:"vuestic-breadcrumbs"},[_c('router-link',{staticClass:"crumb",attrs:{"to":'/'}},[_vm._v(_vm._s(_vm._f("translate")('breadcrumbs.home')))]),_vm._v(" "),_vm._l((_vm.breadcrumbs),function(item,index){return _c('router-link',{key:index,staticClass:"crumb",class:{ disabled: !item.path },attrs:{"to":{path: item.path}}},[_vm._v("\n          "+_vm._s(_vm._f("translate")(item.meta.title))+"\n        ")])})],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fb+g":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aircab.660f6c4.png";

/***/ }),

/***/ "fcTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fdJM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ff/G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'config',
  meta: {
    expanded: false,
    title: 'Configuración',
    iconClass: 'vuestic-icon vuestic-icon-settings'
  },
  children: [{
    name: 'configUsers',
    path: '/config-users',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Usuarios'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/UserList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/UserNew'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':userId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/UserView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'travels/:userId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/UserTravelsView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'logs/:userId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/UserLogsView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'configClients',
    path: '/config-clients',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Clientes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ClientList'),
      meta: {
        title: 'Clientes'
      }
    }, {
      path: 'new',
      props: true,
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ClientView'),
      meta: {
        title: 'Clientes'
      }
    }, {
      path: ':clientId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ClientView'),
      props: true,
      meta: {
        title: 'Clientes'
      }
    }]
  }, {
    name: 'configPermissions',
    path: '/config-permissions',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Permisos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PermissionList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'new',
      props: true,
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PermissionView'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':permissionId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PermissionView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'configAirports',
    path: '/config-airports',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Aeropuertos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/AirportList'),
      meta: {
        title: 'Aeropuertos'
      }
    }, {
      path: 'new',
      props: true,
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/AirportView'),
      meta: {
        title: 'Aeropuertos'
      }
    }, {
      path: ':airportId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/AirportView'),
      props: true,
      meta: {
        title: 'Aeropuertos'
      }
    }]
  }, {
    name: 'configZoneprices',
    path: '/config-zoneprices',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Precios de Zona'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ZonePriceList'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: 'new',
      props: true,
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ZonePriceNew'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':zonePriceId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ZonePriceNew'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }]
  }, {
    name: 'configChargeIntents',
    path: '/config-charge-intents',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Intentos de Cargo'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ChargeIntentList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: ':intentId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ChargeIntentView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'configTelegramUsers',
    path: '/config-telegram-users',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Usuarios Telegram'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/TelegramUserList'),
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'configDrivers',
    path: '/config-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'menu.drivers'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriversList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverNew'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':driverId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'configHolders',
    path: '/config-holders',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Permisionarios'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderList'),
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: ':holderId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }]
  }, {
    name: 'configOwners',
    path: '/config-owners',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Dueños'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/OwnersList'),
      meta: {
        title: 'Dueños'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/OwnerNew'),
      meta: {
        title: 'Dueños'
      }
    }, {
      path: ':ownerId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/OwnerView'),
      props: true,
      meta: {
        title: 'Dueños'
      }
    }]
  }, {
    name: 'configSupervisors',
    path: '/config-supervisors',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Administradores'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SupervisorsList'),
      meta: {
        title: 'Administradores'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SupervisorNew'),
      meta: {
        title: 'Administradores'
      }
    }, {
      path: ':supervisorId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SupervisorView'),
      props: true,
      meta: {
        title: 'Administradores'
      }
    }]
  }, {
    name: 'configCompanies',
    path: '/config-companies',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Compañías'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CompanyList'),
      meta: {
        title: 'Compañías'
      }
    }, {
      path: 'new',
      props: true,
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CompanyView'),
      meta: {
        title: 'Compañías'
      }
    }, {
      path: ':companyI',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CompanyView'),
      props: true,
      meta: {
        title: 'Compañías'
      }
    }]
  }, {
    name: 'configCompanyServices',
    path: '/config-company-services',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Servicios de Compañía'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CompanyServicesList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CompanyServicesView'),
      props: true,
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':companyServiceId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CompanyServicesView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'configCars',
    path: '/config-cars',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Vehículos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarsList'),
      meta: {
        title: 'Vehículos'
      }
    }, {
      path: ':carId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarView'),
      props: true,
      meta: {
        title: 'Vehículo'
      }
    }]
  }, {
    name: 'configModulators',
    path: '/config-modulators',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Moduladores'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ModulatorList'),
      meta: {
        title: 'Modulador'
      }
    }, {
      path: ':userId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ModulatorView'),
      props: true,
      meta: {
        title: 'Modulador'
      }
    }]
  }, {
    name: 'configVirtual',
    path: '/config-virtual',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Colas Asistidas'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/VirtualList'),
      meta: {
        title: 'Colas Asistidas'
      }
    }, {
      path: ':virtualId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/VirtualView'),
      meta: {
        title: 'Colas Asistidas'
      }
    }]
  }, {
    name: 'updateHolders',
    path: '/utils/updateHolders',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/updateHolders'),
    meta: {
      title: 'Actualizar Permisionario',
      requiresAuth: true
    }
  }, {
    name: 'updateDrivers',
    path: '/utils/updateDrivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/updateDrivers'),
    meta: {
      title: 'Actualizar Conductores',
      requiresAuth: true
    }
  }, {
    name: 'updateCars',
    path: '/utils/updateCars',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/updateCars'),
    meta: {
      title: 'Actualizar Vehiculo',
      requiresAuth: true
    }
  }, {
    name: 'configPromoRedeem',
    path: '/config-promo-redeem',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Promociones Canjeadas'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PromoRedeemList'),
      meta: {
        title: 'menu.drivers'
      }
    }]
  }]
});

/***/ }),

/***/ "fjgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "fr7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swapping-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g6j3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle progress-bar",style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"overlay",style:('background-color: ' + _vm.backgroundColor + '; color: ' + _vm.color)},[_c('span',[_vm._v(_vm._s(_vm.animatedValue+'%'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gJkK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TripLayout'
});

/***/ }),

/***/ "gMVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_StickyScroll__ = __webpack_require__("qLPH");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chat',

  directives: { StickyScroll: __WEBPACK_IMPORTED_MODULE_0_vuestic_directives_StickyScroll__["a" /* default */] },

  props: {
    value: {
      type: Array,
      default: []
    },
    isActive: {
      type: Boolean,
      default: true
    },
    height: {
      default: '20rem'
    }
  },

  data: function data() {
    return {
      inputMessage: ''
    };
  },


  methods: {
    keyHandler: function keyHandler(event) {
      if (event.keyCode === 13) {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage() {
      if (this.inputMessage) {
        this.$emit('input', this.value.concat({
          text: this.inputMessage,
          yours: true
        }));
        this.inputMessage = '';
      }
    }
  },

  mounted: function mounted() {
    this.$emit('input', this.value);
  }
});

/***/ }),

/***/ "ghUU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gkKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"looping-rhombuses-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{staticClass:"rhombus",style:(rs),attrs:{"ikey":index}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h+W8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "hBvJ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeCategory.demo.vue": "cLv7",
	"./vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeNode.demo.vue": "M7fT",
	"./vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeRoot.demo.vue": "tBwt",
	"./vuestic-theme/vuestic-components/vuestic-tree-view/vuestic-div-checkbox/SquareWithIcon.demo.vue": "Ej8V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hBvJ";

/***/ }),

/***/ "hLWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["a"] = ({
  hex2rgb: function hex2rgb(hex, opacity) {
    hex = (hex + '').trim();

    var rgb = null;
    var match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

    if (!match) {
      return null;
    }

    rgb = {};

    hex = match[1];

    if (hex.length === 6) {
      rgb.r = parseInt(hex.substring(0, 2), 16);
      rgb.g = parseInt(hex.substring(2, 4), 16);
      rgb.b = parseInt(hex.substring(4, 6), 16);
    } else if (hex.length === 3) {
      rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
      rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
      rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
    }

    rgb.css = 'rgb' + (opacity ? 'a' : '') + '(';
    rgb.css += rgb.r + ',' + rgb.g + ',' + rgb.b;
    rgb.css += (opacity ? ',' + opacity : '') + ')';

    return rgb;
  },
  findInNestedByNameOld: function findInNestedByNameOld(array, name) {
    if (typeof array !== 'undefined') {
      for (var i = 0; i < array.length; i++) {
        if (array[i].name === name) return [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, array[i])];
        var a = this.findInNestedByName(array[i].children, name);
        if (a != null) {
          a.unshift(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, array[i]));
          return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(a));
        }
      }
    }
    return null;
  },
  findInNestedByName: function findInNestedByName(array, path) {
    if (typeof array !== 'undefined') {
      for (var i = 0; i < array.length; i++) {
        if (array[i].path === path) return [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, array[i])];
        var a = this.findInNestedByName(array[i].children, path);
        if (a != null) {
          a.unshift(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, array[i]));
          return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(a));
        }
      }
    }
    return null;
  },
  cutText: function cutText(len, text) {
    var textAux = text;
    if (text.length > len) {
      textAux = text.slice(0, len - 1) + '...';
    }
    return textAux;
  },
  getTypeString: function getTypeString(type) {
    if (type === 'airportScheduled' || type === 'citySchedueled') {
      return 'Ciudad - Aeropuerto';
    }
    return 'Aeropuerto - Ciudad';
  },
  getPlatformString: function getPlatformString(platform) {
    var objString = { android: 'App', ios: 'App', ticket: 'Taquilla', callCenter: 'Call Center' };
    return objString[platform];
  }
});

/***/ }),

/***/ "hXXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bar",staticClass:"vuestic-progress-bar"},[(_vm.type == 'horizontal')?_c('horizontal-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'vertical')?_c('vertical-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'circle')?_c('circle-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"color":_vm.color,"background-color":_vm.backgroundColor,"start-color":_vm.startColor,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i/0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("MEVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4856a8f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("aaOx");
function injectStyle (ssrContext) {
  __webpack_require__("C3zk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4856a8f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "i2ub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datetime__ = __webpack_require__("QEVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datetime_dist_vue_datetime_css__ = __webpack_require__("suTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_datetime_dist_vue_datetime_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'simple-filter',
  components: {
    Datetime: __WEBPACK_IMPORTED_MODULE_0_vue_datetime__["Datetime"]
  },
  props: {
    onFind: {
      type: Function,
      default: function _default(t, m) {
        console.log('On Find', t, m);
      }
    },
    date: {
      type: Object
    },
    selectedField: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    filterText: {
      type: String,
      default: ''
    },
    filterFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formatDate: null,
      searchText: '',
      options: [],
      selected: null,
      showFilter: false
    };
  },
  created: function created() {
    var vue = this;
    vue.searchText = this.filterText;
    if (this.date) vue.formatDate = this.date.format();
    if (vue.filterFields.length > 0) {
      vue.showFilter = true;
      if (vue.selectedField) {
        vue.selected = vue.selectedField;
      } else {
        vue.selected = vue.filterFields[0];
      }
    }
    vue.filterFields.forEach(function (field) {
      vue.options.push(field);
    });
  },

  methods: {
    doFilter: function doFilter() {
      this.onFind(this.formatDate, this.searchText, this.selected);
    }
  }
});

/***/ }),

/***/ "i2v5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iLy1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-profile-card',
  props: ['photoSource', 'name', 'location', 'social']
});

/***/ }),

/***/ "iUpC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ihPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__ = __webpack_require__("4J/c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abc3e72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__ = __webpack_require__("cSfi");
function injectStyle (ssrContext) {
  __webpack_require__("VwpK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1abc3e72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPopover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abc3e72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPopover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "irRG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j+1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"form-group with-icon-right dropdown select-form-group multiselect-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle"},[_c('input',{class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","required":""},domProps:{"value":_vm.displayValue}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.optionKey ? option[_vm.optionKey] : option))]),_vm._v(" "),_c('i',{staticClass:"fa fa-check selected-icon"})])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j1c/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store__ = __webpack_require__("IcnI");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-slider',

  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },

  props: {
    value: {
      type: Number,
      required: true
    },

    options: {
      type: Object
    }
  },

  data: function data() {
    return {
      defaultOptions: {
        dotSize: 16,
        height: 2,
        realTime: true,
        sliderStyle: {
          'background-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary,
          'box-shadow': 'none'
        },
        processStyle: {
          'background-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary
        },
        tooltipStyle: {
          'background-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary,
          'border-color': __WEBPACK_IMPORTED_MODULE_2_vuex_store__["a" /* default */].getters.palette.primary
        }
      }
    };
  },

  computed: {
    sliderOptions: function sliderOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaultOptions, this.options);
    }
  },

  methods: {
    change: function change(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),

/***/ "jEUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("VVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b045cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("oGg2");
function injectStyle (ssrContext) {
  __webpack_require__("EQYl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b045cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jFr3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chart"},[(_vm.type === 'pie')?_c('pie-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'donut')?_c('donut-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'bubble')?_c('bubble-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'line')?_c('line-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'horizontal-bar')?_c('horizontal-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'vertical-bar')?_c('vertical-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jdTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'holder',
  meta: {
    expanded: false,
    title: 'Permisionario',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [{
    name: 'HolderDashboard',
    path: '/holder/dashboard',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/dashboard/Dashboard'),
    meta: {
      title: 'Dashboard'
    }
  }, {
    name: 'HolderMonitor',
    path: '/holder/monitor',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('monitor/google-maps/HolderGoogleMapsPage'),
    meta: {
      title: 'Monitor Permisionario'
    }
  }, {
    name: 'pagos',
    path: '/holder/pagos',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/PaymentList'),
    meta: {
      title: 'Consulta Pagos',
      requiresAuth: true
    }
  }, {
    name: 'HolderDriver',
    path: '/holder-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/Main'),
    meta: {
      title: 'Conductores'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/DriversList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: ':driverId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/DriverView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'Holderars',
    path: '/holder-cars',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/Main'),
    meta: {
      title: 'Vehículos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/CarsList'),
      meta: {
        title: 'Vehículos'
      }
    }, {
      path: ':carId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/holder/CarView'),
      props: true,
      meta: {
        title: 'Vehículo'
      }
    }]
  }]
});

/***/ }),

/***/ "jrTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__ = __webpack_require__("fjgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eafe60d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__ = __webpack_require__("vJDM");
function injectStyle (ssrContext) {
  __webpack_require__("mJ/4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eafe60d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kH5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__ = __webpack_require__("NpL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_54fd4dfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__ = __webpack_require__("rpQ+");
function injectStyle (ssrContext) {
  __webpack_require__("8zBt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54fd4dfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_54fd4dfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kZD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-scrollbar"},[_c('div',{ref:"scrollbarWrapper",staticClass:"scrollbar-wrapper"},[_c('div',{ref:"scrollbarContent",staticClass:"scrollbar-content",on:{"wheel":_vm.scroll,"touchstart":_vm.startDrag,"touchmove":_vm.onDrag,"touchend":_vm.stopDrag,"transitionend":_vm.onContentResize}},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"track",staticClass:"track"},[_c('div',{ref:"thumb",staticClass:"thumb"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kfHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tabs',
  props: ['names'],
  computed: {
    underscoreClass: function underscoreClass() {
      return 'underscore-' + this.names.length + '-' + this.names.indexOf(this.currentActive);
    }
  },
  methods: {
    setActive: function setActive(name) {
      this.currentActive = name;
    }
  },
  data: function data() {
    return {
      currentActive: this.names[0]
    };
  }
});

/***/ }),

/***/ "kl3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: null
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: null
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: [Object, Function],
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    version: function version() {
      return VERSION;
    },
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      if (data === null || typeof data === 'undefined') return;

      this.fireEvent('loading');

      if (Array.isArray(data)) {
        this.tableData = data;
        this.fireEvent('loaded');
        return;
      }

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        var iconTag = this.showSortIcons ? this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"') : '';
        return title + ' ' + iconTag;
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAppendParams(this.getAllQueryParams());

      return this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_1_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};

      if (typeof this.queryParams === 'function') {
        params = this.queryParams(this.sortOrder, this.currentPage, this.perPage);
        return (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(params)) !== 'object' ? {} : params;
      }

      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] === 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }
      return result;
    },
    getAppendParams: function getAppendParams(params) {
      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      if (this.apiMode || this.dataManager) {
        this.loadData();
      }
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortClass: function sortClass(field) {
      var cls = '';
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingClass : this.css.descendingClass;
      }

      return cls;
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        return this.setData(this.data);
      }

      this.normalizeSortOrder();

      return this.setData(this.dataManager ? this.dataManager(this.sortOrder, this.makePagination()) : this.data);
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    onCellRightClicked: function onCellRightClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-rightclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      return this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      return this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    },
    'data': function data(newVal, oldVal) {
      this.setData(newVal);
    },
    'tableHeight': function tableHeight(newVal, oldVal) {
      this.fixHeader();
    }
  }
});

/***/ }),

/***/ "l7V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orbit-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"orbit one",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit two",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit three",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l92n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "lLPG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slider',_vm._b({staticClass:"vuestic-slider",attrs:{"value":_vm.value,"bg-style":_vm.sliderOptions.bgStyle,"slider-style":_vm.sliderOptions.sliderStyle},on:{"input":_vm.change}},'slider',_vm.sliderOptions,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lR6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trips',
  meta: {
    expanded: false,
    title: 'Viajes',
    iconClass: 'fa fa-taxi'
  },
  children: [{
    name: 'tripsFinished',
    path: '/trips/trip-finished',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/Main'),
    meta: {
      title: 'Viajes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/Finished'),
      meta: {
        title: 'Finalizado'
      }
    }, {
      name: 'tripView',
      path: ':travelId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/View'),
      props: true,
      meta: {
        title: 'Finalizado'
      }
    }]
  }, {
    name: 'trips-queue-list',
    path: '/trips/queue-list',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/Main'),
    meta: {
      title: 'Solicitudes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/QueueList'),
      meta: {
        title: 'Solicitud'
      }
    }, {
      path: ':queueId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/QueueView2'),
      props: true,
      meta: {
        title: 'Vista'
      }
    }]
  }, {
    name: 'tripsScheduledTrip',
    path: '/trips/scheduled-trip',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/Main'),
    meta: {
      title: 'Programado'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/Scheduled'),
      meta: {
        title: 'Programado'
      }
    }, {
      name: 'queueView',
      path: ':queueId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('trips/ViewQueue'),
      props: true,
      meta: {
        title: 'Programado'
      }
    }]
  }, {
    name: 'scanQueue',
    path: '/trips/scan-queue',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('travels/ScanQueue'),
    meta: {
      title: 'Escaneos de Boletos',
      requiresAuth: true
    }
  }]
});

/***/ }),

/***/ "laTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),

/***/ "lhlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__ = __webpack_require__("bGbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_315dd7fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__ = __webpack_require__("aN7X");
function injectStyle (ssrContext) {
  __webpack_require__("iUpC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-315dd7fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_315dd7fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"2.8.7","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.full.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","prepublish":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash.merge":"^4.6.0"},"peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),

/***/ "m4M9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intersecting-circles-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinnerBlock",style:(_vm.spinnerBlockStyle)},_vm._l((_vm.circleStyles),function(cs,index){return _c('span',{key:index,staticClass:"circle",style:(cs)})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mJ/4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mPOX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUJ2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./aircabReport/ClientList.vue": [
		"/xcc",
		150
	],
	"./aircabReport/TravelList.vue": [
		"iOkW",
		149
	],
	"./app/ReporteDeudasPersonas.vue": [
		"3rMw",
		212
	],
	"./app/UnfinishTravelList.vue": [
		"EXiV",
		211
	],
	"./app/dashboardCharts/DashboardCharts.vue": [
		"wBcM",
		210
	],
	"./app/debitPayments/DebitPaymentList.vue": [
		"BgZv",
		26
	],
	"./app/debits/Edit.vue": [
		"gW5P",
		304
	],
	"./app/debits/List.vue": [
		"w7GB",
		193
	],
	"./app/debits/Main.vue": [
		"BKU5",
		350
	],
	"./app/debits/New.vue": [
		"hDbM",
		222
	],
	"./app/debits/View.vue": [
		"S4NK",
		28
	],
	"./app/driver/Pagos.vue": [
		"DRSe",
		25
	],
	"./app/holder/CarModal.vue": [
		"gUXH",
		250
	],
	"./app/holder/CarView.vue": [
		"tEAf",
		249
	],
	"./app/holder/CarsList.vue": [
		"3S54",
		192
	],
	"./app/holder/DriverView.vue": [
		"9TPx",
		52
	],
	"./app/holder/DriversList.vue": [
		"1r7l",
		228
	],
	"./app/holder/Main.vue": [
		"2MaG",
		349
	],
	"./app/holder/PaymentList.vue": [
		"bSMs",
		17
	],
	"./app/holder/Sales.vue": [
		"n60K",
		24
	],
	"./app/holder/dashboard/Dashboard.vue": [
		"lH5T",
		46
	],
	"./app/holder/dashboard/DashboardAir.vue": [
		"GSzF",
		191
	],
	"./app/holder/dashboard/DashboardBottomWidgets.vue": [
		"PKUJ",
		303
	],
	"./app/holder/dashboard/DashboardInfoWidgets.vue": [
		"GI5P",
		190
	],
	"./app/holder/dashboard/GoogleMap.vue": [
		"ir4E",
		233
	],
	"./app/holder/dashboard/data-visualisation-tab/DataVisualisation.vue": [
		"uHGO",
		138
	],
	"./app/holder/dashboard/features-tab/FeaturesTab.vue": [
		"KsoM",
		302
	],
	"./app/holder/dashboard/setup-profile-tab/SetupProfileTab.vue": [
		"m+Ze",
		255
	],
	"./app/holder/dashboard/users-and-members-tab/UsersMembersTab.vue": [
		"nSI5",
		301
	],
	"./app/invoices/InvoiceList.vue": [
		"Huil",
		108
	],
	"./app/mypayments/MyPayments.vue": [
		"BFqf",
		122
	],
	"./app/payments/PaymentList.vue": [
		"1mlv",
		35
	],
	"./app/payments/PaymentListTab.vue": [
		"vDTc",
		23
	],
	"./app/promos/PromoList.vue": [
		"+y+C",
		22
	],
	"./app/refunds/List.vue": [
		"xK7m",
		131
	],
	"./app/refunds/Main.vue": [
		"r5Yl",
		348
	],
	"./app/refunds/New.vue": [
		"mDQl",
		221
	],
	"./app/reviews/ReviewList.vue": [
		"ebBP",
		148
	],
	"./app/sales/List.vue": [
		"75ui",
		21
	],
	"./app/supervisor/CarModal.vue": [
		"qf+8",
		248
	],
	"./app/supervisor/CarView.vue": [
		"70KX",
		247
	],
	"./app/supervisor/CarsList.vue": [
		"/ELK",
		189
	],
	"./app/supervisor/DriverView.vue": [
		"MeUn",
		51
	],
	"./app/supervisor/DriversList.vue": [
		"jW+w",
		220
	],
	"./app/supervisor/Main.vue": [
		"J6KV",
		347
	],
	"./app/supervisor/Sales.vue": [
		"M9Zi",
		20
	],
	"./app/supervisor/dashboard/Dashboard.vue": [
		"sMve",
		45
	],
	"./app/supervisor/dashboard/DashboardAir.vue": [
		"Eta9",
		188
	],
	"./app/supervisor/dashboard/DashboardBottomWidgets.vue": [
		"j6Ad",
		300
	],
	"./app/supervisor/dashboard/DashboardInfoWidgets.vue": [
		"1A3J",
		187
	],
	"./app/supervisor/dashboard/GoogleMap.vue": [
		"zdOR",
		232
	],
	"./app/supervisor/dashboard/data-visualisation-tab/DataVisualisation.vue": [
		"Tgwg",
		137
	],
	"./app/supervisor/dashboard/features-tab/FeaturesTab.vue": [
		"xyVz",
		299
	],
	"./app/supervisor/dashboard/setup-profile-tab/SetupProfileTab.vue": [
		"fP6S",
		254
	],
	"./app/supervisor/dashboard/users-and-members-tab/UsersMembersTab.vue": [
		"P6Vo",
		298
	],
	"./auth/login/Login.vue": [
		"mEJK",
		297
	],
	"./auth/signup/Signup.vue": [
		"5rG8",
		296
	],
	"./callCenter/CallcenterClientList.vue": [
		"sFqs",
		295
	],
	"./callCenter/SalesList.vue": [
		"RUrt",
		130
	],
	"./cars/HolderLink.vue": [
		"iYOO",
		346
	],
	"./cars/Holders.vue": [
		"FRwE",
		360
	],
	"./cars/Index.vue": [
		"Gra3",
		114
	],
	"./cars/New.vue": [
		"eQkx",
		121
	],
	"./cars/View.vue": [
		"4XXG",
		120
	],
	"./companies/CompanyActions.vue": [
		"eCHn",
		345
	],
	"./companies/Holders.vue": [
		"Y3vT",
		136
	],
	"./companies/Index.vue": [
		"JZr1",
		135
	],
	"./companies/Main.vue": [
		"9xTP",
		359
	],
	"./companies/View.vue": [
		"Bp3d",
		119
	],
	"./companies/panel/airportTravels.vue": [
		"edHW",
		75
	],
	"./companies/panel/cars.vue": [
		"NTFx",
		80
	],
	"./companies/panel/cityQueues.vue": [
		"gTsO",
		73
	],
	"./companies/panel/finishedTravels.vue": [
		"i2+6",
		53
	],
	"./companies/panel/monitor.vue": [
		"RGcs",
		48
	],
	"./companies/panel/openedTravels.vue": [
		"xGlT",
		78
	],
	"./companies/panel/returnTravels.vue": [
		"o025",
		74
	],
	"./config/AirportList.vue": [
		"XuRZ",
		294
	],
	"./config/AirportView.vue": [
		"THNR",
		293
	],
	"./config/CampaingList.vue": [
		"wuH5",
		344
	],
	"./config/CampaingView.vue": [
		"7XB1",
		104
	],
	"./config/CarModal.vue": [
		"nZYK",
		246
	],
	"./config/CarView.vue": [
		"/BwY",
		245
	],
	"./config/CarsList.vue": [
		"gfCg",
		96
	],
	"./config/ChargeIntentList.vue": [
		"MSr0",
		147
	],
	"./config/ChargeIntentView.vue": [
		"M6OM",
		209
	],
	"./config/ClientList.vue": [
		"hHH4",
		146
	],
	"./config/ClientView.vue": [
		"sYSY",
		361
	],
	"./config/CompanyList.vue": [
		"3kuJ",
		208
	],
	"./config/CompanyServicesList.vue": [
		"ihJR",
		244
	],
	"./config/CompanyServicesView.vue": [
		"HrAP",
		243
	],
	"./config/CompanyView.vue": [
		"W48k",
		292
	],
	"./config/DepositDayList.vue": [
		"p9pW",
		42
	],
	"./config/DepositList.vue": [
		"3BRa",
		41
	],
	"./config/DriverAdminList.vue": [
		"Y07Y",
		186
	],
	"./config/DriverCard.vue": [
		"F7t5",
		59
	],
	"./config/DriverNew.vue": [
		"hqWD",
		107
	],
	"./config/DriverView.vue": [
		"ZCqb",
		50
	],
	"./config/DriversList.vue": [
		"WQ2R",
		219
	],
	"./config/EmployeeView.vue": [
		"+GeE",
		242
	],
	"./config/EmployeesList.vue": [
		"Trgk",
		313
	],
	"./config/ErrorList.vue": [
		"Qw/B",
		227
	],
	"./config/ExpiredDocumentsList.vue": [
		"iQ/M",
		60
	],
	"./config/HolderList.vue": [
		"U3au",
		312
	],
	"./config/HolderView.vue": [
		"YNRD",
		164
	],
	"./config/HolderViewFinance.vue": [
		"3HEI",
		163
	],
	"./config/Main.vue": [
		"uYRf",
		343
	],
	"./config/ModTicketList.vue": [
		"jEHW",
		218
	],
	"./config/ModTicketView.vue": [
		"EGxI",
		40
	],
	"./config/ModulatorList.vue": [
		"QrUO",
		311
	],
	"./config/ModulatorView.vue": [
		"/V5O",
		151
	],
	"./config/OwnerNew.vue": [
		"NpCz",
		342
	],
	"./config/OwnerView.vue": [
		"M62n",
		341
	],
	"./config/OwnersList.vue": [
		"Av+Q",
		340
	],
	"./config/PermissionList.vue": [
		"uBss",
		291
	],
	"./config/PermissionView.vue": [
		"5na0",
		290
	],
	"./config/Preregister.vue": [
		"K46b",
		310
	],
	"./config/PriceList.vue": [
		"RszZ",
		309
	],
	"./config/PriceView.vue": [
		"yNsf",
		201
	],
	"./config/PrintList.vue": [
		"nMJx",
		165
	],
	"./config/PromoList.vue": [
		"SXw+",
		339
	],
	"./config/PromoRedeemList.vue": [
		"STYl",
		145
	],
	"./config/PromoView.vue": [
		"7vkL",
		103
	],
	"./config/PushDriverCheckbox.vue": [
		"Uld2",
		338
	],
	"./config/PushDrivers.vue": [
		"rxBn",
		152
	],
	"./config/PushHistory.vue": [
		"2q+m",
		162
	],
	"./config/PushHistoryDetailBtn.vue": [
		"RGZT",
		337
	],
	"./config/SellerView.vue": [
		"kHCJ",
		160
	],
	"./config/SellersList.vue": [
		"97v6",
		226
	],
	"./config/SubZoneList.vue": [
		"8XbE",
		308
	],
	"./config/SubZoneMap.vue": [
		"sn+S",
		236
	],
	"./config/SubZoneView.vue": [
		"tui/",
		90
	],
	"./config/SupervisorNew.vue": [
		"DnAx",
		241
	],
	"./config/SupervisorView.vue": [
		"77xG",
		240
	],
	"./config/SupervisorsList.vue": [
		"dNDU",
		239
	],
	"./config/TelegramUserList.vue": [
		"qDUg",
		289
	],
	"./config/TicketDayList.vue": [
		"pxi2",
		39
	],
	"./config/TicketDayView.vue": [
		"6Dyy",
		38
	],
	"./config/TicketDriverList.vue": [
		"Q0S9",
		217
	],
	"./config/TicketDriverView.vue": [
		"32hq",
		37
	],
	"./config/TicketList.vue": [
		"nBrf",
		36
	],
	"./config/UserList.vue": [
		"15yG",
		43
	],
	"./config/UserLogsView.vue": [
		"QVd0",
		207
	],
	"./config/UserNew.vue": [
		"YjAe",
		288
	],
	"./config/UserTravelsView.vue": [
		"2NoX",
		144
	],
	"./config/UserView.vue": [
		"/DOE",
		287
	],
	"./config/VirtualList.vue": [
		"SzY3",
		238
	],
	"./config/VirtualView.vue": [
		"5c44",
		336
	],
	"./config/ZoneList.vue": [
		"dhxB",
		307
	],
	"./config/ZonePriceList.vue": [
		"Ptn8",
		306
	],
	"./config/ZonePriceNew.vue": [
		"3lkB",
		123
	],
	"./config/ZoneView.vue": [
		"4p5o",
		200
	],
	"./dashboard/Dashboard.vue": [
		"UE3e",
		44
	],
	"./dashboard/DashboardAir.vue": [
		"Avn2",
		91
	],
	"./dashboard/DashboardBottomWidgets.vue": [
		"g2tC",
		286
	],
	"./dashboard/DashboardCharts.vue": [
		"mPtz",
		206
	],
	"./dashboard/DashboardInfoWidgets.vue": [
		"8D9j",
		185
	],
	"./dashboard/GoogleMap.vue": [
		"ZV1L",
		231
	],
	"./dashboard/data-visualisation-tab/DataVisualisation.vue": [
		"0404",
		134
	],
	"./dashboard/features-tab/FeaturesTab.vue": [
		"ilf6",
		285
	],
	"./dashboard/setup-profile-tab/SetupProfileTab.vue": [
		"hnAi",
		253
	],
	"./dashboard/users-and-members-tab/UsersMembersTab.vue": [
		"HLpY",
		284
	],
	"./deposits/DepositActions.vue": [
		"F5AA",
		335
	],
	"./deposits/Index.vue": [
		"hnsj",
		29
	],
	"./deposits/View.vue": [
		"MY1A",
		199
	],
	"./drivers/Conection.vue": [
		"0KBP",
		113
	],
	"./drivers/DriverLink.vue": [
		"vil7",
		334
	],
	"./drivers/Drivers.vue": [
		"LEC8",
		358
	],
	"./drivers/Index.vue": [
		"cXm/",
		112
	],
	"./drivers/View.vue": [
		"W5eN",
		54
	],
	"./drivers/components/MontlyResume.vue": [
		"r5k8",
		225
	],
	"./extra/Extra.vue": [
		"i3SW",
		49
	],
	"./financial/AircabList.vue": [
		"pKpw",
		143
	],
	"./financial/AircabScheduledList.vue": [
		"b3e8",
		184
	],
	"./financial/Company/AircabList.vue": [
		"XBrO",
		129
	],
	"./financial/Company/CallcenterList.vue": [
		"fPsE",
		128
	],
	"./financial/DailySalesDetail.vue": [
		"Tdkv",
		183
	],
	"./financial/DailySalesList.vue": [
		"4L7H",
		182
	],
	"./financial/DepositDetail.vue": [
		"dg3j",
		34
	],
	"./financial/DepositDetailCar.vue": [
		"QC3a",
		33
	],
	"./financial/DepositList.vue": [
		"G33W",
		127
	],
	"./financial/DepositListCar.vue": [
		"u7E0",
		126
	],
	"./financial/TicketScheduledList.vue": [
		"YA7O",
		181
	],
	"./forms/form-elements/FormElements.vue": [
		"1d7L",
		252
	],
	"./forms/form-wizard/FormWizard.vue": [
		"BIYo",
		251
	],
	"./forms/medium-editor/MediumEditor.vue": [
		"KIGi",
		283
	],
	"./holders/HolderLink.vue": [
		"57fh",
		333
	],
	"./holders/Holders.vue": [
		"LA67",
		357
	],
	"./holders/Index.vue": [
		"z2oq",
		111
	],
	"./holders/New.vue": [
		"6sdE",
		118
	],
	"./holders/View.vue": [
		"jfrG",
		117
	],
	"./layout/AuthLayout.vue": [
		"v6Pz"
	],
	"./layout/Layout.vue": [
		"i/0a"
	],
	"./layout/TripLayout.vue": [
		"KeHD"
	],
	"./layout/navbar/LanguageSelector.vue": [
		"fCLS"
	],
	"./layout/navbar/Navbar.vue": [
		"QI9S"
	],
	"./layout/sidebar/Sidebar.vue": [
		"jEUr"
	],
	"./layout__/AuthLayout.vue": [
		"gzHy",
		282
	],
	"./layout__/Layout.vue": [
		"sKc/",
		65
	],
	"./layout__/TripLayout.vue": [
		"V4cJ",
		281
	],
	"./layout__/navbar/LanguageSelector.vue": [
		"X4wS",
		280
	],
	"./layout__/navbar/Navbar.vue": [
		"ouSC",
		168
	],
	"./layout__/sidebar/Sidebar.vue": [
		"QQh9",
		279
	],
	"./links/CompanyLink.vue": [
		"PMWM",
		332
	],
	"./manualInvoice/ManualInvoice.vue": [
		"worE",
		278
	],
	"./maps/bubble-maps/BubbleMap.vue": [
		"4B14",
		158
	],
	"./maps/bubble-maps/BubbleMapsPage.vue": [
		"Vn7A",
		88
	],
	"./maps/google-maps/GoogleMap.vue": [
		"B2vT",
		235
	],
	"./maps/google-maps/GoogleMapsPage.vue": [
		"mL/o",
		159
	],
	"./maps/leaflet-maps/LeafletMap.vue": [
		"psFn",
		141
	],
	"./maps/leaflet-maps/LeafletMapsPage.vue": [
		"+Tox",
		89
	],
	"./maps/line-maps/LineMap.vue": [
		"8NYS",
		157
	],
	"./maps/line-maps/LineMapsPage.vue": [
		"P0w/",
		85
	],
	"./monitor/bubble-maps/BubbleMap.vue": [
		"gp1Y",
		156
	],
	"./monitor/bubble-maps/BubbleMapsPage.vue": [
		"is1Q",
		87
	],
	"./monitor/google-maps/GoogleMap.vue": [
		"63o4",
		230
	],
	"./monitor/google-maps/GoogleMapsPage.vue": [
		"Her3",
		64
	],
	"./monitor/google-maps/HolderGoogleMapsPage.vue": [
		"lSr9",
		63
	],
	"./monitor/google-maps/MonitorUserLink.vue": [
		"YuHK",
		277
	],
	"./monitor/google-maps/SupervisorGoogleMapsPage copy.vue": [
		"f7Cg",
		62
	],
	"./monitor/google-maps/SupervisorGoogleMapsPage.vue": [
		"Rfsm",
		61
	],
	"./monitor/google-maps/TravelLink.vue": [
		"Qbm7",
		331
	],
	"./monitor/leaflet-maps/LeafletMap.vue": [
		"6e6w",
		116
	],
	"./monitor/leaflet-maps/LeafletMapsPage.vue": [
		"IgnO",
		57
	],
	"./monitor/line-maps/LineMap.vue": [
		"nsq3",
		155
	],
	"./monitor/line-maps/LineMapsPage.vue": [
		"lqVo",
		84
	],
	"./payments/Index.vue": [
		"slBS",
		198
	],
	"./payments/Payments.vue": [
		"7/Y/",
		356
	],
	"./periods/DriverActions.vue": [
		"dg+0",
		216
	],
	"./periods/Index.vue": [
		"k71J",
		133
	],
	"./periods/PeriodActions.vue": [
		"zETN",
		330
	],
	"./periods/Periods.vue": [
		"VHyK",
		355
	],
	"./periods/View.vue": [
		"3cjy",
		82
	],
	"./queues/Accepted.vue": [
		"3UBn",
		101
	],
	"./queues/Active.vue": [
		"gt/J",
		99
	],
	"./queues/ActiveCompany.vue": [
		"MnZx",
		100
	],
	"./queues/All.vue": [
		"q/bG",
		94
	],
	"./queues/BadgeColumn.vue": [
		"6vxS",
		276
	],
	"./queues/Canceled.vue": [
		"UD3n",
		98
	],
	"./queues/Scheduled.vue": [
		"+0Ae",
		93
	],
	"./queues/Unassigned.vue": [
		"tv3o",
		97
	],
	"./roles/EditRol.vue": [
		"scsk",
		329
	],
	"./roles/Index.vue": [
		"ZDno",
		132
	],
	"./roles/Main.vue": [
		"6Lxu",
		354
	],
	"./roles/New.vue": [
		"4GwE",
		275
	],
	"./roles/View.vue": [
		"m2eL",
		274
	],
	"./sharedTrip/GoogleMap.vue": [
		"MJua",
		234
	],
	"./sharedTrip/Main.vue": [
		"vera",
		95
	],
	"./statistics/charts/Charts.vue": [
		"dfb7",
		166
	],
	"./statistics/progress-bars/ProgressBars.vue": [
		"J1Wx",
		273
	],
	"./supervisormonitor/bubble-maps/BubbleMap.vue": [
		"v7J2",
		154
	],
	"./supervisormonitor/bubble-maps/BubbleMapsPage.vue": [
		"fDoC",
		86
	],
	"./supervisormonitor/google-maps/GoogleMap.vue": [
		"+0DI",
		229
	],
	"./supervisormonitor/google-maps/GoogleMapsPage.vue": [
		"8Yfb",
		81
	],
	"./supervisormonitor/google-maps/MonitorUserLink.vue": [
		"rjTZ",
		328
	],
	"./supervisormonitor/google-maps/TravelLink.vue": [
		"oc+w",
		327
	],
	"./supervisormonitor/leaflet-maps/LeafletMap.vue": [
		"7r+3",
		115
	],
	"./supervisormonitor/leaflet-maps/LeafletMapsPage.vue": [
		"pRNg",
		56
	],
	"./supervisormonitor/line-maps/LineMap.vue": [
		"TVSB",
		153
	],
	"./supervisormonitor/line-maps/LineMapsPage.vue": [
		"DysO",
		83
	],
	"./support/ChatList.vue": [
		"ce8k",
		142
	],
	"./support/ChatView.vue": [
		"Hqtr",
		272
	],
	"./support/FieldList.vue": [
		"end8",
		205
	],
	"./support/FieldView.vue": [
		"V+5N",
		271
	],
	"./support/InfoList.vue": [
		"oFwt",
		204
	],
	"./support/InfoView.vue": [
		"9gjY",
		270
	],
	"./support/Main.vue": [
		"9BHb",
		353
	],
	"./tables/BadgeColumn.vue": [
		"csLD",
		269
	],
	"./tables/Table.vue": [
		"7vQb",
		161
	],
	"./template/autocomplete.vue": [
		"syg8",
		326
	],
	"./tools/AssignTicket.vue": [
		"YJHu",
		180
	],
	"./tools/AssignTicketCar.vue": [
		"mV0z",
		179
	],
	"./tools/BadgeColumn.vue": [
		"YRvj",
		268
	],
	"./tools/Canceled.vue": [
		"byG1",
		106
	],
	"./tools/DailyResume.vue": [
		"yM2/",
		224
	],
	"./tools/DriverCut.vue": [
		"+YdP",
		125
	],
	"./tools/DuplicatedTravels.vue": [
		"hXGc",
		197
	],
	"./tools/ListAssignTicket.vue": [
		"1LK6",
		203
	],
	"./tools/ProcessDay copy.vue": [
		"uO6n",
		77
	],
	"./tools/ProcessDay corte manual.vue": [
		"7URJ",
		178
	],
	"./tools/ProcessDay.vue": [
		"+iWr",
		177
	],
	"./tools/ProcessDay210523.vue": [
		"LsZB",
		176
	],
	"./tools/ProcessDayAerotaxi.vue": [
		"sQEW",
		175
	],
	"./tools/ProcessDayPorto.vue": [
		"/k0n",
		174
	],
	"./tools/ProcessDayTicket.vue": [
		"PLwl",
		173
	],
	"./tools/ProcessDay_backup.vue": [
		"O7Bv",
		76
	],
	"./tools/ProcessDay_modal.vue": [
		"SRAC",
		32
	],
	"./tools/ProcessDay_porto.vue": [
		"07ry",
		172
	],
	"./tools/ProcessDayback.vue": [
		"3Jk5",
		171
	],
	"./tools/ProcessWeek.vue": [
		"KgB0",
		170
	],
	"./tools/SaleMonthList.vue": [
		"B6lF",
		267
	],
	"./tools/loadInformation.vue": [
		"xl4N",
		11
	],
	"./tools/reportCards.1.vue": [
		"+Quz",
		10
	],
	"./tools/reportCards.vue": [
		"e3rV",
		0
	],
	"./tools/reportOpenpay.vue": [
		"ONZk",
		31
	],
	"./tools/reportOpenpay__.vue": [
		"xosG",
		12
	],
	"./tools/reportOverdue.vue": [
		"LwxU",
		202
	],
	"./tools/updateCars.vue": [
		"v3H6",
		6
	],
	"./tools/updateDrivers copy.vue": [
		"L2CI",
		9
	],
	"./tools/updateDrivers copy2.vue": [
		"NMFc",
		5
	],
	"./tools/updateDrivers.vue": [
		"cXIP",
		4
	],
	"./tools/updateDriversCars.vue": [
		"5c6F",
		3
	],
	"./tools/updateDriversDrivers.vue": [
		"2yQ2",
		2
	],
	"./tools/updateHolders.vue": [
		"VGvv",
		1
	],
	"./tools/uploadRate.vue": [
		"f1pi",
		8
	],
	"./tools/uploadZone.vue": [
		"aPoI",
		7
	],
	"./tools/usersWithoutOpenpay.vue": [
		"rsH5",
		105
	],
	"./travels/BadgeColumn.vue": [
		"7Ljk",
		266
	],
	"./travels/Canceled.vue": [
		"vCn6",
		72
	],
	"./travels/ClientLink.vue": [
		"xOhl",
		325
	],
	"./travels/ClientTravels.vue": [
		"jI5y",
		71
	],
	"./travels/DriverLink.vue": [
		"gzeM",
		324
	],
	"./travels/DriverProblems.vue": [
		"+TwH",
		70
	],
	"./travels/DriverTravels.vue": [
		"M4ws",
		69
	],
	"./travels/Duplicated.vue": [
		"jcco",
		196
	],
	"./travels/Finished.vue": [
		"hNx5",
		68
	],
	"./travels/Low.vue": [
		"c2NL",
		79
	],
	"./travels/Opened.vue": [
		"A6rd",
		110
	],
	"./travels/ProblemTravels.vue": [
		"WasM",
		67
	],
	"./travels/ScanQueue.vue": [
		"L/EI",
		47
	],
	"./travels/ScanQueueActions.vue": [
		"/cRL",
		323
	],
	"./travels/ScanQueueLink.vue": [
		"Z5r4",
		213
	],
	"./travels/ScanQueueStatus.vue": [
		"mzPB",
		305
	],
	"./travels/ScanQueueTicketModal.vue": [
		"fb9L",
		237
	],
	"./travels/TravelActions.vue": [
		"DeMa",
		322
	],
	"./travels/Travels.vue": [
		"fTlT",
		352
	],
	"./travels/View.vue": [
		"wAnX",
		16
	],
	"./travels/leaflet-maps/LeafletMap.vue": [
		"//Oc",
		140
	],
	"./trips/Finished.vue": [
		"9WbT",
		92
	],
	"./trips/GoogleMap.vue": [
		"uuAc",
		169
	],
	"./trips/InProgress.vue": [
		"qAlg",
		30
	],
	"./trips/Main.vue": [
		"SFgC",
		321
	],
	"./trips/QueueList.vue": [
		"6vqw",
		19
	],
	"./trips/QueueView2.vue": [
		"CU+d",
		15
	],
	"./trips/Scheduled.vue": [
		"qy5w",
		18
	],
	"./trips/TicketList.vue": [
		"vIPq",
		124
	],
	"./trips/ToBeAssigned.vue": [
		"CPcP",
		27
	],
	"./trips/TripLink.vue": [
		"Nv/1",
		320
	],
	"./trips/View.vue": [
		"zh+l",
		14
	],
	"./trips/ViewQueue.vue": [
		"0xS3",
		13
	],
	"./trips/leaflet-maps/LeafletMap.vue": [
		"mdCk",
		139
	],
	"./ui/buttons/Buttons.vue": [
		"906U",
		265
	],
	"./ui/grid/Grid.vue": [
		"B8IG",
		264
	],
	"./ui/icons/Icons.vue": [
		"qzeV",
		55
	],
	"./ui/icons/Set.vue": [
		"G7oI",
		263
	],
	"./ui/icons/SetsList.vue": [
		"uaIo",
		262
	],
	"./ui/modals/Modals.vue": [
		"g/Tc",
		261
	],
	"./ui/notifications/Notifications.vue": [
		"hiVg",
		167
	],
	"./ui/notifications/ToastPositionPicker.vue": [
		"9me2",
		260
	],
	"./ui/spinners/Spinners.vue": [
		"jNlQ",
		259
	],
	"./ui/tree-view/TreeView.vue": [
		"sN7A",
		58
	],
	"./ui/tree-view/TreeViewAdvancedPreview.vue": [
		"9Kgs",
		319
	],
	"./ui/tree-view/TreeViewBasicPreview.vue": [
		"HAQJ",
		318
	],
	"./ui/tree-view/TreeViewEditablePreview.vue": [
		"QtuA",
		258
	],
	"./ui/tree-view/TreeViewIconsPreview.vue": [
		"gFSd",
		317
	],
	"./ui/tree-view/TreeViewSelectablePreview.vue": [
		"3svY",
		316
	],
	"./ui/typography/Typography.vue": [
		"5VNW",
		257
	],
	"./users/Index.vue": [
		"Wfkm",
		195
	],
	"./users/Main.vue": [
		"+zTT",
		351
	],
	"./users/UserLink.vue": [
		"pXdp",
		315
	],
	"./users/View.vue": [
		"J60W",
		256
	],
	"./weeks/Debts.vue": [
		"7f0+",
		214
	],
	"./weeks/DebtsActions.vue": [
		"P8iX",
		314
	],
	"./weeks/GeneratorActions.vue": [
		"TqzF",
		215
	],
	"./weeks/Index.vue": [
		"iLSj",
		194
	],
	"./weeks/WeekGenerator.vue": [
		"fv8X",
		109
	],
	"./weeks/listWeekUser.vue": [
		"o+er",
		223
	],
	"./zoneMap/LeafletMap.vue": [
		"hHOx",
		102
	],
	"./zoneMap/LeafletMapsPage.vue": [
		"0q/H",
		66
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "mWYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('en', __webpack_require__("UpdR"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('es', __webpack_require__("WlTu"));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set('en');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.fallback('en');

/***/ }),

/***/ "mdWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tree-category"},[_c('div',{staticClass:"vuestic-tree-category__header"},[_c('div',{staticClass:"vuestic-tree-category__header-checkbox"},[_c('square-with-icon',{attrs:{"iconClass":_vm.checkboxIconClass},nativeOn:{"click":function($event){_vm.isOpenCached = ! _vm.isOpenCached}}})],1),_vm._v(" "),(_vm.$slots.icon)?_c('div',{staticClass:"vuestic-tree-category__header-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vuestic-tree-category__header-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])]),_vm._v(" "),(_vm.isOpenCached)?_c('div',{staticClass:"vuestic-tree-category__list-container"},[_c('div',{staticClass:"vuestic-tree-category__list-internal-container"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ml8A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "nDIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"left":"420px","top":"180px","background-color":"white","position":"absolute"}},[_c('square-with-icon',{attrs:{"iconClass":"ion ion-md-checkmark"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nErf":
/***/ (function(module, exports) {

module.exports = [{"x":0,"y":0},{"x":8,"y":12},{"x":16,"y":24},{"x":24,"y":36},{"x":32,"y":48},{"x":40,"y":60},{"x":48,"y":72},{"x":60,"y":84},{"x":72,"y":72},{"x":80,"y":60},{"x":88,"y":48},{"x":96,"y":36},{"x":104,"y":24},{"x":112,"y":12},{"x":120,"y":0},{"x":104,"y":0},{"x":88,"y":0},{"x":80,"y":12},{"x":72,"y":24},{"x":60,"y":36},{"x":48,"y":24},{"x":40,"y":10},{"x":32,"y":0},{"x":16,"y":0}]

/***/ }),

/***/ "nEss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manualInvoice',
  path: '/manualInvoice',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('manualInvoice/ManualInvoice'),
  meta: {
    default: false,
    title: 'Factura Manual',
    iconClass: 'fa fa-money',
    requiresAuth: true
  }
});

/***/ }),

/***/ "niZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__ = __webpack_require__("/XqH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231a81d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__ = __webpack_require__("hXXU");
function injectStyle (ssrContext) {
  __webpack_require__("3w5z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_231a81d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nn+q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "noQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el) {
    var getWindowMatch = function getWindowMatch() {
      return window.matchMedia(__WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.config.windowMatchSizeLg).matches;
    };

    var prevMatchlg = getWindowMatch();

    el.addEventListener('transitionend', function () {
      __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', false);
    });

    window.addEventListener('resize', function () {
      if (getWindowMatch() && !prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', true);
      } else if (!getWindowMatch() && prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', true);
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', false);
      }
      prevMatchlg = getWindowMatch();
    });
  }
});

/***/ }),

/***/ "oG3h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuesticTreeRoot_vue__ = __webpack_require__("vHzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VuesticTreeNode__ = __webpack_require__("IkPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VuesticTreeCategory__ = __webpack_require__("WXh0");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VuesticTreeCategory: __WEBPACK_IMPORTED_MODULE_2__VuesticTreeCategory__["a" /* default */], VuesticTreeNode: __WEBPACK_IMPORTED_MODULE_1__VuesticTreeNode__["a" /* default */], VuesticTreeRoot: __WEBPACK_IMPORTED_MODULE_0__VuesticTreeRoot_vue__["a" /* default */] }
});

/***/ }),

/***/ "oGg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},[_c('vuestic-scrollbar',[_c('ul',{staticClass:"sidebar-menu"},_vm._l((_vm.menuItems),function(item){return (item.name != 'auth' && _vm.access.includes(item.name) || item.name === 'Forms')?_c('li',{key:item.name},[(item.path)?_c('router-link',{staticClass:"sidebar-link",attrs:{"to":item.path,"target":item.meta.newWindow ? '_blank' : '_self'},on:{"click":function($event){_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("\n          "+_vm._s(_vm._f("translate")(item.meta.title))+"\n        ")]):_c('a',{staticClass:"sidebar-link",class:{expanded: item.meta.expanded},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("\n          "+_vm._s(_vm._f("translate")(item.meta.title))+"\n          "),_c('i',{staticClass:"expand-icon fa fa-angle-down"})]),_vm._v(" "),_c('expanding',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(item.meta.expanded),expression:"item.meta.expanded"}],staticClass:"sidebar-submenu in"},_vm._l((item.children),function(childItem){return _c('li',{key:childItem.name},[_c('router-link',{staticClass:"sidebar-link sidebar-submenu-link",attrs:{"to":childItem.path,"target":childItem.meta.newWindow ? '_blank' : '_self'}},[(childItem.meta.iconClass)?_c('i',{staticClass:"sidebar-menu-item-icon",class:childItem.meta.iconClass}):_vm._e(),_vm._v("\n                "+_vm._s(_vm._f("translate")(childItem.meta.title))+"\n              ")])],1)}))])],1):_vm._e()}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oK+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_parse__ = __webpack_require__("Gi9x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LanguageSelector__ = __webpack_require__("fCLS");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar',

  components: {
    LanguageSelector: __WEBPACK_IMPORTED_MODULE_3__LanguageSelector__["default"]
  },

  data: function data() {
    return {
      username: '',
      langs: [{
        code: 'gb',
        name: 'english'
      }, {
        code: 'es',
        name: 'spanish'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['sidebarOpened', 'toggleWithoutAnimation'])),
  created: function created() {
    var u = __WEBPACK_IMPORTED_MODULE_1_services_parse__["a" /* default */].User.current();
    this.username = u.get('firstName') + ' ' + u.get('lastName');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['closeMenu', 'toggleSidebar', 'isToggleWithoutAnimation']), {
    logout: function logout() {
      var vue = this;
      __WEBPACK_IMPORTED_MODULE_1_services_parse__["a" /* default */].User.logOut().then(function () {
        console.log('logout');
        vue.$router.push('/auth/login');
      });
    }
  })
});

/***/ }),

/***/ "oKE4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-social-news',
  props: ['news', 'url']
});

/***/ }),

/***/ "obAf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datatable_components_FilterBar_vue__ = __webpack_require__("s0HW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datatable_components_ItemsPerPage_vue__ = __webpack_require__("evu/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__ = __webpack_require__("7qYU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuestic_datatable_data_data_table_styles__ = __webpack_require__("KMiR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_epic_spinners__ = __webpack_require__("pyJd");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-data-table',
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_5__datatable_components_FilterBar_vue__["a" /* default */],
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_6__datatable_components_ItemsPerPage_vue__["a" /* default */],
    FulfillingSquareSpinner: __WEBPACK_IMPORTED_MODULE_10_epic_spinners__["FulfillingSquareSpinner"]
  },
  props: {
    filterQuery: {
      type: String,
      default: 'filter'
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage;
      }
    },
    perPageSelectorShown: {
      type: Boolean,
      default: true
    },
    headerShown: {
      type: Boolean,
      default: true
    },
    filterInputShown: {
      type: Boolean,
      default: true
    },
    defaultPerPage: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage[0].value
    },
    onEachSide: {
      type: Number,
      default: 2
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Object,
      default: function _default() {
        return {
          data: []
        };
      }
    },
    dataModeFilterableFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: ''
    },
    detailRowClass: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      perPage: 0,
      colorClasses: {},
      filterText: '',
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_9__vuestic_datatable_data_data_table_styles__["a" /* default */]
    };
  },

  computed: {
    controlsAlignmentClass: function controlsAlignmentClass() {
      return {
        'justify-content-md-between': this.filterInputShown,
        'justify-content-md-end': !this.filterInputShown
      };
    },
    moreParams: function moreParams() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, this.filterQuery, this.filterText);
    },
    dataModeFilterableFieldsComputed: function dataModeFilterableFieldsComputed() {
      var dataItem = this.tableData.data[0] || {};
      var filterableFields = this.dataModeFilterableFields;

      if (!filterableFields.length) {
        var itemFields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataItem);
        itemFields.forEach(function (field) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(dataItem[field]) !== 'object') {
            filterableFields.push(field);
          }
        });
      }

      return filterableFields;
    },
    filteredTableData: function filteredTableData() {
      var _this = this;

      var txt = new RegExp(this.filterText, 'i');

      var filteredData = this.tableData.data.slice();

      filteredData = this.tableData.data.filter(function (item) {
        return _this.dataModeFilterableFieldsComputed.some(function (field) {
          var val = item[field] + '';
          return val.search(txt) >= 0;
        });
      });

      return {
        data: filteredData
      };
    },
    defaultPerPageComputed: function defaultPerPageComputed() {
      var defaultPerPage = __WEBPACK_IMPORTED_MODULE_7__data_items_per_page_definition__["a" /* default */].itemsPerPage[0].value;

      if (this.$options.propsData.defaultPerPage) {
        defaultPerPage = this.$options.propsData.defaultPerPage;
      } else if (this.$options.propsData.itemsPerPage) {
        defaultPerPage = this.$options.propsData.itemsPerPage[0].value;
      }

      return defaultPerPage;
    },
    paginationPathComputed: function paginationPathComputed() {
      return this.apiMode ? this.paginationPath : 'pagination';
    }
  },

  created: function created() {
    console.log('Table Created');
    this.perPage = this.defaultPerPageComputed;
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log('Table Mounted');
    this.perPage = this.defaultPerPageComputed;
    __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
      return _this2.$refs.vuetable.refresh();
    });
  },


  methods: {
    onFilterSet: function onFilterSet(filterText) {
      var _this3 = this;

      this.filterText = filterText;
      __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this4 = this;

      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
        return _this4.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      console.log(page);
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.filteredTableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === 'desc') {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    },
    arrowClicked: function arrowClicked(data, field, event) {
      this.$emit('change-map-center', data.position);
    }
  }
});

/***/ }),

/***/ "oiPi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mypayments',
  path: '/mypayments',

  component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/mypayments/MyPayments'),
  meta: {
    default: false,
    title: 'Mis pagos',
    iconClass: 'fa fa-money',
    requiresAuth: true
  }
});

/***/ }),

/***/ "pDEH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'driverPagos',
  meta: {
    expanded: false,
    title: 'Listado de Pagos',
    iconClass: 'vuestic-icon vuestic-icon-auth'
  },
  children: [{
    name: 'driverPagos',
    path: '/driverpagos/:driverId',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('app/driver/Pagos'),
    meta: {
      title: 'Pagos',
      requiresAuth: false
    }
  }]
});

/***/ }),

/***/ "pjCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tree-root',
  methods: {
    collapse: function collapse() {
      var _this = this;

      this.$nextTick(function () {
        _this.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.collapse();
          }
        });
      });
    },
    expand: function expand() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$children.forEach(function (child) {
          if (child.$options.name === 'vuestic-tree-category') {
            child.expand();
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "q2yJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-pre-loader"},[_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qB2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-feed',
  props: ['initialPosts'],
  methods: {
    removePost: function removePost(target) {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var post = _step.value;

          if (post !== target) {
            result.push(post);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.posts = result;
    }
  },
  data: function data() {
    return {
      posts: this.initialPosts
    };
  }
});

/***/ }),

/***/ "qHzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("h+W8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_30ba2881_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("fr7E");
function injectStyle (ssrContext) {
  __webpack_require__("8wbO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30ba2881"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_30ba2881_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qLPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var duration = binding.value.duration || 500;
    var isAnimated = binding.value.animate;

    var observer = new MutationObserver(scrollToBottom);
    var config = { childList: true };
    observer.observe(el, config);

    function animateScroll(duration) {
      var start = el.scrollTop;
      var end = el.scrollHeight;
      var change = end - start;
      var increment = 20;

      function easeInOut(currentTime, start, change, duration) {
        currentTime /= duration / 2;
        if (currentTime < 1) {
          return change / 2 * currentTime * currentTime + start;
        }
        currentTime -= 1;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
      }

      function animate(elapsedTime) {
        elapsedTime += increment;
        var position = easeInOut(elapsedTime, start, change, duration);
        el.scrollTop = position;

        if (elapsedTime < duration) {
          setTimeout(function () {
            animate(elapsedTime);
          }, increment);
        }
      }

      animate(0);
    }

    function scrollToBottom() {
      if (isAnimated) {
        animateScroll(duration);
      } else {
        el.scrollTop = el.scrollHeight;
      }
    }
  }
});

/***/ }),

/***/ "qoIK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "quJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"id":"input-icon-left","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter()},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r/aY":
/***/ (function(module, exports, __webpack_require__) {



var browser = __webpack_require__("bJUU");
var erd = __webpack_require__("uk2G")();

var vm = {
  name: 'vuestic-scrollbar',
  props: {
    speed: {
      default: 20
    }
  },
  methods: {
    calcSize: function calcSize() {
      this.isDown = this.isUp = false;
      this.maxHeight = parseFloat(this.wrapper.offsetHeight, 10);
      this.contentHeight = parseFloat(this.content.offsetHeight, 10);
      this.trackHeight = parseFloat(this.track.offsetHeight, 10);
      this.thumb.style.height = this.maxHeight / this.contentHeight * this.trackHeight + 'px';
      if (this.maxHeight / this.contentHeight < 1) {
        this.thumb.classList.add('active');
      } else {
        this.thumb.classList.remove('active');
      }
    },
    calcThumb: function calcThumb() {
      var currentMT = this.content.style.marginTop === '' ? 0 : parseInt(this.content.style.marginTop, 10);
      this.thumb.style.top = -currentMT / this.contentHeight * this.trackHeight + 'px';
    },
    onContentResize: function onContentResize() {
      var _this = this;

      var prevHeight = this.contentHeight;
      this.calcSize();
      this.calcThumb();

      this.content.style.transition = 'margin-top .3s linear';
      this.thumb.style.transition = 'top .3s linear';
      var handler = function handler(e) {
        if (e.propertyName === 'margin-top') {
          _this.content.style.transition = '';
          _this.calcSize();
          _this.calcThumb();
          _this.content.removeEventListener('transitionend', handler);
          _this.thumb.style.transition = '';
        }
      };
      this.content.addEventListener('transitionend', handler);

      this.setVertical(this.contentHeight - prevHeight);
    },
    startDrag: function startDrag(e) {
      this.isDragging = true;
      this.prevTouch = e.touches[0];
    },
    onDrag: function onDrag(e) {
      if (this.isDragging) {
        e.preventDefault();
        var touch = e.touches[0];
        var delta = this.prevTouch.clientY - touch.clientY;
        this.setVertical(delta);
        this.prevTouch = touch;
      }
    },
    stopDrag: function stopDrag(e) {
      this.isDragging = false;
    },
    scroll: function scroll(e) {
      var delta = e.deltaY * 0.01 * this.speed;
      if (browser.name === 'firefox') {
        delta *= 10;
      }
      this.setVertical(delta);
      e.preventDefault();
    },
    setVertical: function setVertical(delta) {
      if (this.isDown && delta > 0 || this.isUp && delta < 0 || this.contentHeight <= this.maxHeight) {
        return;
      }
      var currentMT = this.content.style.marginTop === '' ? 0 : parseFloat(this.content.style.marginTop, 10);
      var nextMT = 0;
      if (this.maxHeight - (currentMT - delta) > this.contentHeight && delta > 0) {
        nextMT = this.maxHeight - this.contentHeight;
        this.isDown = true;
      } else {
        this.isDown = false;
        if (currentMT - delta > 0) {
          this.isUp = true;
          nextMT = 0;
        } else {
          nextMT = currentMT - delta;
          this.isUp = false;
        }
      }

      this.content.style.marginTop = nextMT + 'px';
      this.calcThumb();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.track = this.$refs.track;
    this.thumb = this.$refs.thumb;
    this.content = this.$refs.scrollbarContent;
    this.wrapper = this.$refs.scrollbarWrapper;
    this.calcSize();
    this.calcThumb();
    erd.listenTo(this.content, function () {
      _this2.calcSize();
      _this2.calcThumb();
    });
  },
  beforeDestroy: function beforeDestroy() {
    erd.removeAllListeners(this.content);
  },
  data: function data() {
    return {
      wrapper: undefined,
      maxHeight: undefined,
      thumb: undefined,
      track: undefined,
      trackHeight: undefined,
      content: undefined,
      contentHeight: undefined,
      isDown: false,
      isUp: true,
      prevTouch: {},
      isDragging: false
    };
  }
};

module.exports = vm;

/***/ }),

/***/ "r2QC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-switch"},[_c('div',{staticClass:"vuestic-switch-option true-option",class:{'active': _vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(true)}}},[_vm._t("trueTitle")],2),_vm._v(" "),_c('div',{staticClass:"vuestic-switch-option false-option",class:{'active': !_vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(false)}}},[_vm._t("falseTitle")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r8Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "rNhy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rpQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"semipolar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"ring",style:(rs)})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s+US":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'startColor', 'backgroundColor', 'isActive'],
  computed: {
    backgroundImage: function backgroundImage() {
      var result = {};
      if (this.animatedValue < 50) {
        var nextDeg = 90 + 3.6 * this.animatedValue + 'deg';
        result = 'linear-gradient(90deg, ' + this.startColor + ' 50%, transparent 50%, transparent), linear-gradient(' + nextDeg + ', ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      } else {
        var _nextDeg = -90 + 3.6 * (this.animatedValue - 50) + 'deg';
        result = 'linear-gradient(' + _nextDeg + ', ' + this.color + ' 50%, transparent 50%, transparent), linear-gradient(270deg, ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      }
      return result;
    }
  }
});

/***/ }),

/***/ "s0HW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("Kss2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6ab28f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("quJE");
function injectStyle (ssrContext) {
  __webpack_require__("WO+O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b6ab28f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6ab28f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "siFy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "suTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tBwt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_demo_vue__ = __webpack_require__("oG3h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f160838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_demo_vue__ = __webpack_require__("ZXLX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f160838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tcEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "tgcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__ = __webpack_require__("/VHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_962247b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__ = __webpack_require__("jW0v");
function injectStyle (ssrContext) {
  __webpack_require__("vNtF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_962247b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u+5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__ = __webpack_require__("P+0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4f0820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__ = __webpack_require__("RfGv");
function injectStyle (ssrContext) {
  __webpack_require__("Hqax")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4f0820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMediumEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u5sW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tools',
  meta: {
    expanded: false,
    title: 'Herramientas',
    iconClass: 'vuestic-icon vuestic-icon-statistics'
  },
  children: [{
    name: 'processDay',
    path: '/utils/process-day',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/ProcessDay'),
    meta: {
      title: 'Proceso del Día',
      requiresAuth: true
    }
  }, {
    name: 'processDayAerotaxi',
    path: '/utils/process-day-aerotaxi',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/ProcessDayAerotaxi'),
    meta: {
      title: 'Proceso del Día Aerotaxi',
      requiresAuth: true
    }
  }, {
    name: 'reportCreditCard',
    path: '/utils/report-credit-card',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/reportCards'),
    meta: {
      title: 'Subir Reporte Mensual de EBSA',
      requiresAuth: true
    }
  }, {
    name: 'uploadZone',
    path: '/utils/upload-zone',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/uploadZone'),
    meta: {
      title: 'Subir Zonas',
      requiresAuth: true
    }
  }, {
    name: 'uploadRate',
    path: '/utils/upload-rate',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/uploadRate'),
    meta: {
      title: 'Subir Tarifas',
      requiresAuth: true
    }
  }, {
    name: 'saleMonthList',
    path: '/utils/sale-month-list',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('tools/SaleMonthList'),
    meta: {
      title: 'Listado de ventas',
      requiresAuth: true
    }
  }]
});

/***/ }),

/***/ "uLZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"beforeEnter":_vm.beforeEnter,"afterEnter":_vm.afterEnter,"beforeLeave":_vm.beforeLeave,"afterLeave":_vm.afterLeave}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uMWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trinity-rings-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle1",style:(_vm.ring1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle2",style:(_vm.ring2Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle3",style:(_vm.ring3Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ubP3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uqOk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__ = __webpack_require__("f8CP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b70f487_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__ = __webpack_require__("5zUm");
function injectStyle (ssrContext) {
  __webpack_require__("uqOk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b70f487_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v6Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__("GB0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bec07bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__("X5DT");
function injectStyle (ssrContext) {
  __webpack_require__("Z9/R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bec07bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vHzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__ = __webpack_require__("pjCh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d04b206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__ = __webpack_require__("Vliu");
function injectStyle (ssrContext) {
  __webpack_require__("nn+q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d04b206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTreeRoot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vJDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical"},[_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('height: ' + _vm.value + '%')})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vNtF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vW50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("TqEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c614a6dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("m4M9");
function injectStyle (ssrContext) {
  __webpack_require__("Omos")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c614a6dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c614a6dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vYCf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pixel-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"pixel-spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vbwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleFilter_vue__ = __webpack_require__("i2ub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05abf7e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleFilter_vue__ = __webpack_require__("XZd5");
function injectStyle (ssrContext) {
  __webpack_require__("AJrP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05abf7e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05abf7e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vh2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticBreadcrumbs_vue__ = __webpack_require__("yBS9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74431532_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticBreadcrumbs_vue__ = __webpack_require__("fVS2");
function injectStyle (ssrContext) {
  __webpack_require__("8QAW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74431532"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticBreadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74431532_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticBreadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vi3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "vnff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'support',
  meta: {
    expanded: false,
    title: 'Asistencia',
    iconClass: 'vuestic-icon vuestic-icon-comments'
  },
  children: [{
    name: 'supportChat',
    path: '/support-chat',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/Main'),
    meta: {
      title: 'Chat de Soporte'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/ChatList'),
      meta: {
        title: 'Chat de Soporte'
      }
    }, {
      path: ':supportId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/ChatView'),
      props: true,
      meta: {
        title: 'Chat de Soporte'
      }
    }]
  }, {
    name: 'supportField',
    path: '/support-field',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/Main'),
    meta: {
      title: 'Campos de Ayuda'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/FieldList'),
      meta: {
        title: 'Campos de Ayuda'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/FieldView'),
      props: true,
      meta: {
        title: 'Campos de Ayuda'
      }
    }, {
      path: ':suppordFieldId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/FieldView'),
      props: true,
      meta: {
        title: 'Campos de Ayuda'
      }
    }]
  }, {
    name: 'supportInfo',
    path: '/support-info',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/Main'),
    meta: {
      title: 'Información de Soporte'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/InfoList'),
      meta: {
        title: 'Información de Soporte'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/InfoView'),
      props: true,
      meta: {
        title: 'Información de Soporte'
      }
    }, {
      path: ':suppordInfodId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('support/InfoView'),
      props: true,
      meta: {
        title: 'Información de Soporte'
      }
    }]
  }]
});

/***/ }),

/***/ "wIuh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'callCenter',
  meta: {
    expanded: false,
    title: 'Call Center',
    iconClass: 'vuestic-icon vuestic-icon-statistics'
  },
  children: [{
    name: 'callcenterReportSales',
    path: '/callcenter-report/sales',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Reporte Ventas'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('callCenter/SalesList'),
      meta: {
        title: 'Reporte Ventas'
      }
    }]
  }, {
    name: 'callcenterReportClients',
    path: '/callcenter-report/clients',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Reporte Clientes'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('callCenter/CallcenterClientList'),
      meta: {
        title: 'Reporte Clientes'
      }
    }]
  }]
});

/***/ }),

/***/ "waXG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x4Ng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'language-selector',

  props: {
    options: {
      type: Array,
      required: true
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['closeMenu']), {
    setLanguage: function setLanguage(locale) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.set(locale);
    },
    currentLanguage: function currentLanguage() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.locale() === 'en' ? 'gb' : __WEBPACK_IMPORTED_MODULE_1_vue__["default"].i18n.locale();
    },
    flagIconClass: function flagIconClass(code) {
      return 'flag-icon-' + code;
    }
  })
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_layout_Layout__ = __webpack_require__("i/0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout_TripLayout__ = __webpack_require__("KeHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_layout_AuthLayout__ = __webpack_require__("v6Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("9xHH");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    VuesticPreLoader: __WEBPACK_IMPORTED_MODULE_3_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["a" /* default */],
    AuthLayout: __WEBPACK_IMPORTED_MODULE_2_components_layout_AuthLayout__["default"],
    Layout: __WEBPACK_IMPORTED_MODULE_0_components_layout_Layout__["default"],
    TripLayout: __WEBPACK_IMPORTED_MODULE_1_components_layout_TripLayout__["default"]
  },
  computed: {
    isAuth: function isAuth() {
      var isAuth = this.$route.path.match('auth');

      return isAuth;
    },
    isShareTrip: function isShareTrip() {
      var is = this.$route.name;

      return is === 'sharedTrip' || is === 'driverCard' || is === 'driverPagos';
    }
  }
});

/***/ }),

/***/ "xQQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__ = __webpack_require__("eGfA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc9cdf2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__ = __webpack_require__("AQHc");
function injectStyle (ssrContext) {
  __webpack_require__("mPOX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbc9cdf2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc9cdf2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xrBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__ = __webpack_require__("ZoX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_70558468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__ = __webpack_require__("vYCf");
function injectStyle (ssrContext) {
  __webpack_require__("UA7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70558468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_70558468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yBS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-breadcrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      default: []
    }
  }
});

/***/ }),

/***/ "yPiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__ = __webpack_require__("YPsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8c5533_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__ = __webpack_require__("r2QC");
function injectStyle (ssrContext) {
  __webpack_require__("QYFS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8c5533_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ymQ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'padron',
  meta: {
    expanded: false,
    title: 'Padrón',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [{
    name: 'padronConfigDrivers',
    path: '/config-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'menu.drivers'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriversList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverNew'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':driverId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    name: 'padronConfigHolders',
    path: '/config-holders',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Permisionarios'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderList'),
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: ':holderId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }]
  }, {
    name: 'padronConfigSupervisors',
    path: '/config-supervisors',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Supervisores'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SupervisorsList'),
      meta: {
        title: 'Supervisores'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SupervisorNew'),
      meta: {
        title: 'Supervisores'
      }
    }, {
      path: ':supervisorId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/SupervisorView'),
      props: true,
      meta: {
        title: 'Supervisores'
      }
    }]
  }, {
    name: 'padronConfigCars',
    path: '/config-cars',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Vehículos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarsList'),
      meta: {
        title: 'Vehículos'
      }
    }, {
      path: ':carId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarView'),
      props: true,
      meta: {
        title: 'Vehículo'
      }
    }]
  }, {
    name: 'padronConfigEmployees',
    path: '/config-employees',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Empleados'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/EmployeesList'),
      meta: {
        title: 'Empleados'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/EmployeeView'),
      props: true,
      meta: {
        title: 'Empleado'
      }
    }, {
      path: ':employeeId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/EmployeeView'),
      props: true,
      meta: {
        title: 'Empleados'
      }
    }]
  }, {
    name: 'padronExpiredDocuments',
    path: '/expired-documents',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Documentos Vencidos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/ExpiredDocumentsList'),
      meta: {
        title: 'Documentos Vencidos'
      }
    }]
  }, {
    name: 'padronConfigAdminDrivers',
    path: '/config-admin-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Auto Administrable'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverAdminList'),
      meta: {
        title: 'Auto Administrable'
      }
    }]
  }, {
    name: 'prints',
    path: '/prints',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Impresiones'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PrintList'),
      meta: {
        title: 'Impresiones'
      }
    }]
  }, {
    name: 'padronPushDrivers',
    path: '/push-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Push Conductores'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/PushDrivers'),
      meta: {
        title: 'Push Conductores'
      }
    }]
  }]
});

/***/ }),

/***/ "yqnu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z4eX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner"},[_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-circle",style:(_vm.circleStyle)},[_vm._v("\n      ●\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zKJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"widget-header"},[_vm._v(_vm._s(_vm.headerText))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zb58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("dPe/");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "zdOw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lazyLoading__ = __webpack_require__("O3lU");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'padronBasic',
  meta: {
    expanded: false,
    title: 'Padrón',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [{
    path: '/config-drivers',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'menu.drivers'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriversList'),
      meta: {
        title: 'menu.drivers'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverNew'),
      meta: {
        title: 'Sub Zonas'
      }
    }, {
      path: ':driverId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/DriverView'),
      props: true,
      meta: {
        title: 'menu.drivers'
      }
    }]
  }, {
    path: '/config-holders',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Permisionarios'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderList'),
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: 'new',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }, {
      path: ':holderId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/HolderView'),
      props: true,
      meta: {
        title: 'Permisionarios'
      }
    }]
  }, {
    path: '/config-cars',
    component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/Main'),
    meta: {
      title: 'Vehículos'
    },
    children: [{
      path: '',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarsList'),
      meta: {
        title: 'Vehículos'
      }
    }, {
      path: ':carId',
      component: Object(__WEBPACK_IMPORTED_MODULE_0__lazyLoading__["a" /* default */])('config/CarView'),
      props: true,
      meta: {
        title: 'Vehículo'
      }
    }]
  }]
});

/***/ }),

/***/ "zkRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8b6886e3e748afd5e014.js